/* tslint:disable */
/* eslint-disable */
/**
 * Public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var AuthenticityMethod;
(function (AuthenticityMethod) {
    AuthenticityMethod["CertificateNumber"] = "certificate_number";
    AuthenticityMethod["Fabricks"] = "fabricks";
    AuthenticityMethod["None"] = "none";
})(AuthenticityMethod || (AuthenticityMethod = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BidType;
(function (BidType) {
    BidType["Quickbid"] = "quickbid";
    BidType["Bid"] = "bid";
    BidType["AutomaticBid"] = "automatic_bid";
})(BidType || (BidType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BiddingBlockedReason;
(function (BiddingBlockedReason) {
    BiddingBlockedReason["NoShipmentToTurkey"] = "no_shipment_to_turkey";
})(BiddingBlockedReason || (BiddingBlockedReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BiddingStatus;
(function (BiddingStatus) {
    BiddingStatus["Leading"] = "leading";
    BiddingStatus["Outbid"] = "outbid";
    BiddingStatus["NoBidPlaced"] = "no_bid_placed";
})(BiddingStatus || (BiddingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BidsStatusFilters;
(function (BidsStatusFilters) {
    BidsStatusFilters["All"] = "all";
    BidsStatusFilters["Live"] = "live";
    BidsStatusFilters["Won"] = "won";
    BidsStatusFilters["Closed"] = "closed";
})(BidsStatusFilters || (BidsStatusFilters = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CategoriesSearchType;
(function (CategoriesSearchType) {
    CategoriesSearchType["Teams"] = "teams";
    CategoriesSearchType["Leagues"] = "leagues";
    CategoriesSearchType["Other"] = "other";
    CategoriesSearchType["Campaigns"] = "campaigns";
})(CategoriesSearchType || (CategoriesSearchType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CategoryType;
(function (CategoryType) {
    CategoryType["Country"] = "country";
    CategoryType["League"] = "league";
    CategoryType["Team"] = "team";
    CategoryType["Sport"] = "sport";
    CategoryType["Other"] = "other";
    CategoryType["Gender"] = "gender";
    CategoryType["Athlete"] = "athlete";
    CategoryType["Condition"] = "condition";
    CategoryType["Highlight"] = "highlight";
    CategoryType["Campaign"] = "campaign";
})(CategoryType || (CategoryType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ClientChannel;
(function (ClientChannel) {
    ClientChannel["App"] = "app";
    ClientChannel["Web"] = "web";
})(ClientChannel || (ClientChannel = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CombineType;
(function (CombineType) {
    CombineType["And"] = "and";
    CombineType["Or"] = "or";
})(CombineType || (CombineType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DateSortAttribute;
(function (DateSortAttribute) {
    DateSortAttribute["StartDate"] = "start_date";
    DateSortAttribute["EndDate"] = "end_date";
})(DateSortAttribute || (DateSortAttribute = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DateSortDirection;
(function (DateSortDirection) {
    DateSortDirection["Ascending"] = "ascending";
    DateSortDirection["Descending"] = "descending";
})(DateSortDirection || (DateSortDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DiscountTypeDto;
(function (DiscountTypeDto) {
    DiscountTypeDto["NotAttributed"] = "not_attributed";
    DiscountTypeDto["All"] = "all";
    DiscountTypeDto["Upsell"] = "upsell";
})(DiscountTypeDto || (DiscountTypeDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventSortAttribute;
(function (EventSortAttribute) {
    EventSortAttribute["StartDate"] = "start_date";
    EventSortAttribute["EndDate"] = "end_date";
    EventSortAttribute["EndDateClosestToNow"] = "end_date_closest_to_now";
})(EventSortAttribute || (EventSortAttribute = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventSorting;
(function (EventSorting) {
    EventSorting["Featured"] = "featured";
    EventSorting["ClosingTimeFirstToLast"] = "closing_time_first_to_last";
    EventSorting["ClosingTimeLastToFirst"] = "closing_time_last_to_first";
})(EventSorting || (EventSorting = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EventStatus;
(function (EventStatus) {
    EventStatus["Upcoming"] = "upcoming";
    EventStatus["Live"] = "live";
    EventStatus["Finished"] = "finished";
})(EventStatus || (EventStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FilterEventStatus;
(function (FilterEventStatus) {
    FilterEventStatus["Upcoming"] = "upcoming";
    FilterEventStatus["Live"] = "live";
    FilterEventStatus["Finished"] = "finished";
})(FilterEventStatus || (FilterEventStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FramingStatus;
(function (FramingStatus) {
    FramingStatus["AwaitingFraming"] = "awaiting_framing";
    FramingStatus["Framed"] = "framed";
    FramingStatus["NotFramed"] = "not_framed";
})(FramingStatus || (FramingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FramingType;
(function (FramingType) {
    FramingType["NotFrameable"] = "not_frameable";
    FramingType["Frameable"] = "frameable";
    FramingType["Framed"] = "framed";
})(FramingType || (FramingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ImageOrigin;
(function (ImageOrigin) {
    ImageOrigin["Mockup"] = "mockup";
    ImageOrigin["Photo"] = "photo";
    ImageOrigin["Unknown"] = "unknown";
    ImageOrigin["Filler"] = "filler";
    ImageOrigin["Gallery"] = "gallery";
})(ImageOrigin || (ImageOrigin = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var LiveStatus;
(function (LiveStatus) {
    LiveStatus["Historical"] = "historical";
    LiveStatus["Live"] = "live";
    LiveStatus["Upcoming"] = "upcoming";
    LiveStatus["Started"] = "started";
})(LiveStatus || (LiveStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderItemType;
(function (OrderItemType) {
    OrderItemType["Sku"] = "sku";
    OrderItemType["VirtualTicket"] = "virtual_ticket";
    OrderItemType["Frame"] = "frame";
    OrderItemType["Refund"] = "refund";
})(OrderItemType || (OrderItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["Open"] = "open";
    OrderPaymentStatus["Processing"] = "processing";
    OrderPaymentStatus["Paid"] = "paid";
    OrderPaymentStatus["Closed"] = "closed";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PersonGender;
(function (PersonGender) {
    PersonGender["Female"] = "female";
    PersonGender["Male"] = "male";
    PersonGender["Other"] = "other";
})(PersonGender || (PersonGender = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProductListingFavouritesSortingField;
(function (ProductListingFavouritesSortingField) {
    ProductListingFavouritesSortingField["ClosingTime"] = "closing_time";
    ProductListingFavouritesSortingField["Price"] = "price";
})(ProductListingFavouritesSortingField || (ProductListingFavouritesSortingField = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProductSorting;
(function (ProductSorting) {
    ProductSorting["Featured"] = "featured";
    ProductSorting["ClosingTimeFirstToLast"] = "closing_time_first_to_last";
    ProductSorting["ClosingTimeLastToFirst"] = "closing_time_last_to_first";
    ProductSorting["PriceLowToHigh"] = "price_low_to_high";
    ProductSorting["PriceHighToLow"] = "price_high_to_low";
})(ProductSorting || (ProductSorting = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ProductStatus;
(function (ProductStatus) {
    ProductStatus["Live"] = "live";
    ProductStatus["Finished"] = "finished";
})(ProductStatus || (ProductStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SalesMethod;
(function (SalesMethod) {
    SalesMethod["Sweepstakes"] = "sweepstakes";
    SalesMethod["Bidding"] = "bidding";
    SalesMethod["FixedPrice"] = "fixed_price";
})(SalesMethod || (SalesMethod = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SalesTaxType;
(function (SalesTaxType) {
    SalesTaxType["Unknown"] = "unknown";
    SalesTaxType["NoSalesTax"] = "no_sales_tax";
    SalesTaxType["Vat"] = "vat";
    SalesTaxType["UsSalesTax"] = "us_sales_tax";
    SalesTaxType["BrazilSalesTax"] = "brazil_sales_tax";
})(SalesTaxType || (SalesTaxType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SearchTypeFilter;
(function (SearchTypeFilter) {
    SearchTypeFilter["Events"] = "events";
    SearchTypeFilter["Products"] = "products";
    SearchTypeFilter["Categories"] = "categories";
})(SearchTypeFilter || (SearchTypeFilter = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["NotShipped"] = "not_shipped";
    ShipmentStatus["Shipped"] = "shipped";
})(ShipmentStatus || (ShipmentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ShippingType;
(function (ShippingType) {
    ShippingType["PaidShipping"] = "paid_shipping";
    ShippingType["FreeShipping"] = "free_shipping";
    ShippingType["NoShipping"] = "no_shipping";
    ShippingType["FreeDomesticShipping"] = "free_domestic_shipping";
})(ShippingType || (ShippingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "ascending";
    SortDirection["Descending"] = "descending";
})(SortDirection || (SortDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Sorting;
(function (Sorting) {
    Sorting["Ascending"] = "ascending";
    Sorting["Descending"] = "descending";
})(Sorting || (Sorting = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SuspensionStatus;
(function (SuspensionStatus) {
    SuspensionStatus["NotSuspended"] = "not_suspended";
    SuspensionStatus["SoftSuspended"] = "soft_suspended";
    SuspensionStatus["HardSuspended"] = "hard_suspended";
})(SuspensionStatus || (SuspensionStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VatExemptionReason;
(function (VatExemptionReason) {
    VatExemptionReason["NotExempted"] = "not_exempted";
    VatExemptionReason["IsVatReversed"] = "is_vat_reversed";
    VatExemptionReason["IsExport"] = "is_export";
    VatExemptionReason["IsVatExempt"] = "is_vat_exempt";
    VatExemptionReason["UsSalesTaxApplies"] = "us_sales_tax_applies";
})(VatExemptionReason || (VatExemptionReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VatNumberCheckStatus;
(function (VatNumberCheckStatus) {
    VatNumberCheckStatus["NoVatNumberSet"] = "no_vat_number_set";
    VatNumberCheckStatus["NotChecked"] = "not_checked";
    VatNumberCheckStatus["CheckedNotValid"] = "checked_not_valid";
    VatNumberCheckStatus["CheckedAndValid"] = "checked_and_valid";
    VatNumberCheckStatus["NonEuNumber"] = "non_eu_number";
})(VatNumberCheckStatus || (VatNumberCheckStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VerificationTier;
(function (VerificationTier) {
    VerificationTier["Temporary"] = "temporary";
    VerificationTier["Permanent"] = "permanent";
    VerificationTier["Verified"] = "verified";
    VerificationTier["BidBlocked"] = "bid_blocked";
    VerificationTier["Suspended"] = "suspended";
})(VerificationTier || (VerificationTier = {}));
/**
 * AdyenPaymentsApi - axios parameter creator
 * @export
 */
export const AdyenPaymentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {V2AdyenPaymentFinishPostRequest} [v2AdyenPaymentFinishPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdyenPaymentFinishPost: (xPlatformKey, v2AdyenPaymentFinishPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2AdyenPaymentFinishPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/adyen/payment-finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2AdyenPaymentFinishPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdyenPaymentsApi - functional programming interface
 * @export
 */
export const AdyenPaymentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdyenPaymentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {V2AdyenPaymentFinishPostRequest} [v2AdyenPaymentFinishPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdyenPaymentFinishPost(xPlatformKey, v2AdyenPaymentFinishPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2AdyenPaymentFinishPost(xPlatformKey, v2AdyenPaymentFinishPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdyenPaymentsApi - factory interface
 * @export
 */
export const AdyenPaymentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdyenPaymentsApiFp(configuration);
    return {
        /**
         *
         * @param {AdyenPaymentsApiV2AdyenPaymentFinishPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2AdyenPaymentFinishPost(requestParameters, options) {
            return localVarFp.v2AdyenPaymentFinishPost(requestParameters.xPlatformKey, requestParameters.v2AdyenPaymentFinishPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdyenPaymentsApi - object-oriented interface
 * @export
 * @class AdyenPaymentsApi
 * @extends {BaseAPI}
 */
export class AdyenPaymentsApi extends BaseAPI {
    /**
     *
     * @param {AdyenPaymentsApiV2AdyenPaymentFinishPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdyenPaymentsApi
     */
    v2AdyenPaymentFinishPost(requestParameters, options) {
        return AdyenPaymentsApiFp(this.configuration).v2AdyenPaymentFinishPost(requestParameters.xPlatformKey, requestParameters.v2AdyenPaymentFinishPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BidsApi - axios parameter creator
 * @export
 */
export const BidsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId]
         * @param {number} [bid]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidCostsGet: (xPlatformKey, productId, bid, currency, destinationCountryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2BidCostsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/bid/costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (productId !== undefined) {
                localVarQueryParameter['product_id'] = productId;
            }
            if (bid !== undefined) {
                localVarQueryParameter['bid'] = bid;
            }
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['destination_country_code'] = destinationCountryCode;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BidsApi - functional programming interface
 * @export
 */
export const BidsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BidsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [productId]
         * @param {number} [bid]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidCostsGet(xPlatformKey, productId, bid, currency, destinationCountryCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2BidCostsGet(xPlatformKey, productId, bid, currency, destinationCountryCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BidsApi - factory interface
 * @export
 */
export const BidsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BidsApiFp(configuration);
    return {
        /**
         *
         * @param {BidsApiV2BidCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2BidCostsGet(requestParameters, options) {
            return localVarFp.v2BidCostsGet(requestParameters.xPlatformKey, requestParameters.productId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BidsApi - object-oriented interface
 * @export
 * @class BidsApi
 * @extends {BaseAPI}
 */
export class BidsApi extends BaseAPI {
    /**
     *
     * @param {BidsApiV2BidCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BidsApi
     */
    v2BidCostsGet(requestParameters, options) {
        return BidsApiFp(this.configuration).v2BidCostsGet(requestParameters.xPlatformKey, requestParameters.productId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a category by id
         * @param {string} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdGet: (categoryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2CategoriesCategoryIdGet', 'categoryId', categoryId);
            const localVarPath = `/v2/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the total gross amount raised for a category
         * @param {string} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdTotalRaisedGet: (categoryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2CategoriesCategoryIdTotalRaisedGet', 'categoryId', categoryId);
            const localVarPath = `/v2/categories/{categoryId}/total-raised`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [relatedCategorySlug]
         * @param {FilterEventStatus} [eventStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesEventsGet: (relatedCategorySlug, eventStatus, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/categories/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (relatedCategorySlug !== undefined) {
                localVarQueryParameter['related_category_slug'] = relatedCategorySlug;
            }
            if (eventStatus !== undefined) {
                localVarQueryParameter['event_status'] = eventStatus;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all categories
         * @param {string} [searchTerm] Search term to filter on
         * @param {CategoryType} [type] Only return the provided type of category
         * @param {string} [categoryIds] Only return the categories matching the provided ids
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesGet: (searchTerm, type, categoryIds, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the categories with live events  if types is empty it will use team, other category types by default  the ordering of the types are important, if a event has more than 1 of the category types provided,  it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<CategoryType>} [types]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesLiveEventsGet: (xPlatformKey, types, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesLiveEventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/categories/live-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a category by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugGet: (slug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugGet', 'slug', slug);
            const localVarPath = `/v2/categories/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all related categories by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelatedGet: (slug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugRelatedGet', 'slug', slug);
            const localVarPath = `/v2/categories/{slug}/related`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a category by id
         * @param {string} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdGet(categoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesCategoryIdGet(categoryId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the total gross amount raised for a category
         * @param {string} categoryId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdTotalRaisedGet(categoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesCategoryIdTotalRaisedGet(categoryId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} [relatedCategorySlug]
         * @param {FilterEventStatus} [eventStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesEventsGet(relatedCategorySlug, eventStatus, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesEventsGet(relatedCategorySlug, eventStatus, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all categories
         * @param {string} [searchTerm] Search term to filter on
         * @param {CategoryType} [type] Only return the provided type of category
         * @param {string} [categoryIds] Only return the categories matching the provided ids
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesGet(searchTerm, type, categoryIds, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesGet(searchTerm, type, categoryIds, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the categories with live events  if types is empty it will use team, other category types by default  the ordering of the types are important, if a event has more than 1 of the category types provided,  it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<CategoryType>} [types]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesLiveEventsGet(xPlatformKey, types, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesLiveEventsGet(xPlatformKey, types, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a category by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugGet(slug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesSlugGet(slug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all related categories by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelatedGet(slug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesSlugRelatedGet(slug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary Get a category by id
         * @param {CategoriesApiV2CategoriesCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdGet(requestParameters, options) {
            return localVarFp.v2CategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the total gross amount raised for a category
         * @param {CategoriesApiV2CategoriesCategoryIdTotalRaisedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesCategoryIdTotalRaisedGet(requestParameters, options) {
            return localVarFp.v2CategoriesCategoryIdTotalRaisedGet(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CategoriesApiV2CategoriesEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesEventsGet(requestParameters = {}, options) {
            return localVarFp.v2CategoriesEventsGet(requestParameters.relatedCategorySlug, requestParameters.eventStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all categories
         * @param {CategoriesApiV2CategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesGet(requestParameters = {}, options) {
            return localVarFp.v2CategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the categories with live events  if types is empty it will use team, other category types by default  the ordering of the types are important, if a event has more than 1 of the category types provided,  it will be shown under most important category type, and the importance of the types are in the order you give
         * @param {CategoriesApiV2CategoriesLiveEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesLiveEventsGet(requestParameters, options) {
            return localVarFp.v2CategoriesLiveEventsGet(requestParameters.xPlatformKey, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a category by slug
         * @param {CategoriesApiV2CategoriesSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugGet(requestParameters, options) {
            return localVarFp.v2CategoriesSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all related categories by slug
         * @param {CategoriesApiV2CategoriesSlugRelatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugRelatedGet(requestParameters, options) {
            return localVarFp.v2CategoriesSlugRelatedGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     *
     * @summary Get a category by id
     * @param {CategoriesApiV2CategoriesCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesCategoryIdGet(requestParameters, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the total gross amount raised for a category
     * @param {CategoriesApiV2CategoriesCategoryIdTotalRaisedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesCategoryIdTotalRaisedGet(requestParameters, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesCategoryIdTotalRaisedGet(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CategoriesApiV2CategoriesEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesEventsGet(requestParameters = {}, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesEventsGet(requestParameters.relatedCategorySlug, requestParameters.eventStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all categories
     * @param {CategoriesApiV2CategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesGet(requestParameters = {}, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the categories with live events  if types is empty it will use team, other category types by default  the ordering of the types are important, if a event has more than 1 of the category types provided,  it will be shown under most important category type, and the importance of the types are in the order you give
     * @param {CategoriesApiV2CategoriesLiveEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesLiveEventsGet(requestParameters, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesLiveEventsGet(requestParameters.xPlatformKey, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a category by slug
     * @param {CategoriesApiV2CategoriesSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesSlugGet(requestParameters, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all related categories by slug
     * @param {CategoriesApiV2CategoriesSlugRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    v2CategoriesSlugRelatedGet(requestParameters, options) {
        return CategoriesApiFp(this.configuration).v2CategoriesSlugRelatedGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CategoryEventsApi - axios parameter creator
 * @export
 */
export const CategoryEventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get events for a category
         * @param {string} slug
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] Only return events for these category slugs
         * @param {boolean} [highlighted]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {'start_date' | 'end_date' | 'end_date_closest_to_now'} [sortBy] Used to indicate the sort field, there is also other SortBy Fields that might overwrite the end result  For example if fetching highlighted ones, then the order is influenced by the priority order first
         * @param {'ascending' | 'descending'} [sortDirection] Used to indicate the sort direction
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugEventsGet: (slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, sortBy, sortDirection, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugEventsGet', 'slug', slug);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesSlugEventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/categories/{slug}/events`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (filterOnSlugs !== undefined) {
                localVarQueryParameter['filter_on_slugs'] = filterOnSlugs;
            }
            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }
            if (endDateMin !== undefined) {
                localVarQueryParameter['end_date.min'] = (endDateMin instanceof Date) ?
                    endDateMin.toISOString() :
                    endDateMin;
            }
            if (endDateMax !== undefined) {
                localVarQueryParameter['end_date.max'] = (endDateMax instanceof Date) ?
                    endDateMax.toISOString() :
                    endDateMax;
            }
            if (startDateMin !== undefined) {
                localVarQueryParameter['start_date.min'] = (startDateMin instanceof Date) ?
                    startDateMin.toISOString() :
                    startDateMin;
            }
            if (startDateMax !== undefined) {
                localVarQueryParameter['start_date.max'] = (startDateMax instanceof Date) ?
                    startDateMax.toISOString() :
                    startDateMax;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CategoryEventsApi - functional programming interface
 * @export
 */
export const CategoryEventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoryEventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get events for a category
         * @param {string} slug
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] Only return events for these category slugs
         * @param {boolean} [highlighted]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {'start_date' | 'end_date' | 'end_date_closest_to_now'} [sortBy] Used to indicate the sort field, there is also other SortBy Fields that might overwrite the end result  For example if fetching highlighted ones, then the order is influenced by the priority order first
         * @param {'ascending' | 'descending'} [sortDirection] Used to indicate the sort direction
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugEventsGet(slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, sortBy, sortDirection, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesSlugEventsGet(slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, sortBy, sortDirection, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CategoryEventsApi - factory interface
 * @export
 */
export const CategoryEventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoryEventsApiFp(configuration);
    return {
        /**
         *
         * @summary Get events for a category
         * @param {CategoryEventsApiV2CategoriesSlugEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugEventsGet(requestParameters, options) {
            return localVarFp.v2CategoriesSlugEventsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoryEventsApi - object-oriented interface
 * @export
 * @class CategoryEventsApi
 * @extends {BaseAPI}
 */
export class CategoryEventsApi extends BaseAPI {
    /**
     *
     * @summary Get events for a category
     * @param {CategoryEventsApiV2CategoriesSlugEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryEventsApi
     */
    v2CategoriesSlugEventsGet(requestParameters, options) {
        return CategoryEventsApiFp(this.configuration).v2CategoriesSlugEventsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CategoryProductsApi - axios parameter creator
 * @export
 */
export const CategoryProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get products for a category
         * @param {string} slug
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] Only return events for these category slugs
         * @param {boolean} [highlighted]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugProductsGet: (slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2CategoriesSlugProductsGet', 'slug', slug);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2CategoriesSlugProductsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/categories/{slug}/products`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (filterOnSlugs !== undefined) {
                localVarQueryParameter['filter_on_slugs'] = filterOnSlugs;
            }
            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }
            if (endDateMin !== undefined) {
                localVarQueryParameter['end_date.min'] = (endDateMin instanceof Date) ?
                    endDateMin.toISOString() :
                    endDateMin;
            }
            if (endDateMax !== undefined) {
                localVarQueryParameter['end_date.max'] = (endDateMax instanceof Date) ?
                    endDateMax.toISOString() :
                    endDateMax;
            }
            if (startDateMin !== undefined) {
                localVarQueryParameter['start_date.min'] = (startDateMin instanceof Date) ?
                    startDateMin.toISOString() :
                    startDateMin;
            }
            if (startDateMax !== undefined) {
                localVarQueryParameter['start_date.max'] = (startDateMax instanceof Date) ?
                    startDateMax.toISOString() :
                    startDateMax;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CategoryProductsApi - functional programming interface
 * @export
 */
export const CategoryProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = CategoryProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get products for a category
         * @param {string} slug
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [filterOnSlugs] Only return events for these category slugs
         * @param {boolean} [highlighted]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugProductsGet(slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CategoriesSlugProductsGet(slug, xPlatformKey, filterOnSlugs, highlighted, endDateMin, endDateMax, startDateMin, startDateMax, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CategoryProductsApi - factory interface
 * @export
 */
export const CategoryProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CategoryProductsApiFp(configuration);
    return {
        /**
         *
         * @summary Get products for a category
         * @param {CategoryProductsApiV2CategoriesSlugProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CategoriesSlugProductsGet(requestParameters, options) {
            return localVarFp.v2CategoriesSlugProductsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CategoryProductsApi - object-oriented interface
 * @export
 * @class CategoryProductsApi
 * @extends {BaseAPI}
 */
export class CategoryProductsApi extends BaseAPI {
    /**
     *
     * @summary Get products for a category
     * @param {CategoryProductsApiV2CategoriesSlugProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryProductsApi
     */
    v2CategoriesSlugProductsGet(requestParameters, options) {
        return CategoryProductsApiFp(this.configuration).v2CategoriesSlugProductsGet(requestParameters.slug, requestParameters.xPlatformKey, requestParameters.filterOnSlugs, requestParameters.highlighted, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Finalize a B2C frame configuration
         * @param {string} configurationId
         * @param {V2ConfigurationsConfigurationIdCheckoutPostRequest} [v2ConfigurationsConfigurationIdCheckoutPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ConfigurationsConfigurationIdCheckoutPost: (configurationId, v2ConfigurationsConfigurationIdCheckoutPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'configurationId' is not null or undefined
            assertParamExists('v2ConfigurationsConfigurationIdCheckoutPost', 'configurationId', configurationId);
            const localVarPath = `/v2/configurations/{configurationId}/checkout`
                .replace(`{${"configurationId"}}`, encodeURIComponent(String(configurationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2ConfigurationsConfigurationIdCheckoutPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         * Finalize a B2C frame configuration
         * @param {string} configurationId
         * @param {V2ConfigurationsConfigurationIdCheckoutPostRequest} [v2ConfigurationsConfigurationIdCheckoutPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ConfigurationsConfigurationIdCheckoutPost(configurationId, v2ConfigurationsConfigurationIdCheckoutPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ConfigurationsConfigurationIdCheckoutPost(configurationId, v2ConfigurationsConfigurationIdCheckoutPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigurationApiFp(configuration);
    return {
        /**
         * Finalize a B2C frame configuration
         * @param {ConfigurationApiV2ConfigurationsConfigurationIdCheckoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ConfigurationsConfigurationIdCheckoutPost(requestParameters, options) {
            return localVarFp.v2ConfigurationsConfigurationIdCheckoutPost(requestParameters.configurationId, requestParameters.v2ConfigurationsConfigurationIdCheckoutPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * Finalize a B2C frame configuration
     * @param {ConfigurationApiV2ConfigurationsConfigurationIdCheckoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    v2ConfigurationsConfigurationIdCheckoutPost(requestParameters, options) {
        return ConfigurationApiFp(this.configuration).v2ConfigurationsConfigurationIdCheckoutPost(requestParameters.configurationId, requestParameters.v2ConfigurationsConfigurationIdCheckoutPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/storyblok/content/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesLogosGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/storyblok/content/categories/logos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2StoryblokContentCategoriesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesLogosGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2StoryblokContentCategoriesLogosGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContentApiFp(configuration);
    return {
        /**
         *
         * @summary Storyblok endpoint that returns the Category names and slugs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesGet(options) {
            return localVarFp.v2StoryblokContentCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Storyblok endpoint that returns the Category slugs and logoUrls
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2StoryblokContentCategoriesLogosGet(options) {
            return localVarFp.v2StoryblokContentCategoriesLogosGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     *
     * @summary Storyblok endpoint that returns the Category names and slugs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    v2StoryblokContentCategoriesGet(options) {
        return ContentApiFp(this.configuration).v2StoryblokContentCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Storyblok endpoint that returns the Category slugs and logoUrls
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    v2StoryblokContentCategoriesLogosGet(options) {
        return ContentApiFp(this.configuration).v2StoryblokContentCategoriesLogosGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CountriesApi - axios parameter creator
 * @export
 */
export const CountriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CountriesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CountriesApi - functional programming interface
 * @export
 */
export const CountriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CountriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CountriesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CountriesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CountriesApi - factory interface
 * @export
 */
export const CountriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CountriesApiFp(configuration);
    return {
        /**
         *
         * @summary Gets all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CountriesGet(options) {
            return localVarFp.v2CountriesGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CountriesApi - object-oriented interface
 * @export
 * @class CountriesApi
 * @extends {BaseAPI}
 */
export class CountriesApi extends BaseAPI {
    /**
     *
     * @summary Gets all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountriesApi
     */
    v2CountriesGet(options) {
        return CountriesApiFp(this.configuration).v2CountriesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the available currencies
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CurrenciesGet: (offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the available currencies
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CurrenciesGet(offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CurrenciesGet(offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CurrenciesApiFp(configuration);
    return {
        /**
         *
         * @summary Get the available currencies
         * @param {CurrenciesApiV2CurrenciesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CurrenciesGet(requestParameters = {}, options) {
            return localVarFp.v2CurrenciesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     *
     * @summary Get the available currencies
     * @param {CurrenciesApiV2CurrenciesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    v2CurrenciesGet(requestParameters = {}, options) {
        return CurrenciesApiFp(this.configuration).v2CurrenciesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary List all events.
         * @param {string} xPlatformKey Select the platform.
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {'start_date' | 'end_date' | 'end_date_closest_to_now'} [sort] Used to indicate the field to sort on
         * @param {'ascending' | 'descending'} [sortBy] Used to indicate the sort direction
         * @param {string} [categoryIdsString] Used to filter by one or more category ids
         * @param {boolean} [highlighted] When true will return all the highlighted events, when false will return only non-highlighted events
         * @param {boolean} [homePageVisibility] [Deprecated] When true exclude events with ExcludeFromHomePage set to true.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsGet: (xPlatformKey, endDateMin, endDateMax, startDateMin, startDateMax, sort, sortBy, categoryIdsString, highlighted, homePageVisibility, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (endDateMin !== undefined) {
                localVarQueryParameter['end_date.min'] = (endDateMin instanceof Date) ?
                    endDateMin.toISOString() :
                    endDateMin;
            }
            if (endDateMax !== undefined) {
                localVarQueryParameter['end_date.max'] = (endDateMax instanceof Date) ?
                    endDateMax.toISOString() :
                    endDateMax;
            }
            if (startDateMin !== undefined) {
                localVarQueryParameter['start_date.min'] = (startDateMin instanceof Date) ?
                    startDateMin.toISOString() :
                    startDateMin;
            }
            if (startDateMax !== undefined) {
                localVarQueryParameter['start_date.max'] = (startDateMax instanceof Date) ?
                    startDateMax.toISOString() :
                    startDateMax;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (categoryIdsString !== undefined) {
                localVarQueryParameter['category_ids_string'] = categoryIdsString;
            }
            if (highlighted !== undefined) {
                localVarQueryParameter['highlighted'] = highlighted;
            }
            if (homePageVisibility !== undefined) {
                localVarQueryParameter['home_page_visibility'] = homePageVisibility;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a specific event.
         * @param {string} id The identifier uniquely referring to this event. This can be its id or slug.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsIdGet: (id, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2EventsIdGet', 'id', id);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsIdGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary List all events.
         * @param {string} xPlatformKey Select the platform.
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Date} [startDateMin]
         * @param {Date} [startDateMax]
         * @param {'start_date' | 'end_date' | 'end_date_closest_to_now'} [sort] Used to indicate the field to sort on
         * @param {'ascending' | 'descending'} [sortBy] Used to indicate the sort direction
         * @param {string} [categoryIdsString] Used to filter by one or more category ids
         * @param {boolean} [highlighted] When true will return all the highlighted events, when false will return only non-highlighted events
         * @param {boolean} [homePageVisibility] [Deprecated] When true exclude events with ExcludeFromHomePage set to true.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsGet(xPlatformKey, endDateMin, endDateMax, startDateMin, startDateMax, sort, sortBy, categoryIdsString, highlighted, homePageVisibility, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2EventsGet(xPlatformKey, endDateMin, endDateMax, startDateMin, startDateMax, sort, sortBy, categoryIdsString, highlighted, homePageVisibility, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a specific event.
         * @param {string} id The identifier uniquely referring to this event. This can be its id or slug.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsIdGet(id, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2EventsIdGet(id, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventsApiFp(configuration);
    return {
        /**
         *
         * @summary List all events.
         * @param {EventsApiV2EventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsGet(requestParameters, options) {
            return localVarFp.v2EventsGet(requestParameters.xPlatformKey, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sort, requestParameters.sortBy, requestParameters.categoryIdsString, requestParameters.highlighted, requestParameters.homePageVisibility, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific event.
         * @param {EventsApiV2EventsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsIdGet(requestParameters, options) {
            return localVarFp.v2EventsIdGet(requestParameters.id, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     *
     * @summary List all events.
     * @param {EventsApiV2EventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    v2EventsGet(requestParameters, options) {
        return EventsApiFp(this.configuration).v2EventsGet(requestParameters.xPlatformKey, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.startDateMin, requestParameters.startDateMax, requestParameters.sort, requestParameters.sortBy, requestParameters.categoryIdsString, requestParameters.highlighted, requestParameters.homePageVisibility, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a specific event.
     * @param {EventsApiV2EventsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    v2EventsIdGet(requestParameters, options) {
        return EventsApiFp(this.configuration).v2EventsIdGet(requestParameters.id, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * EventsOverviewApi - axios parameter creator
 * @export
 */
export const EventsOverviewApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {DateSortAttribute} [sortBy]
         * @param {DateSortDirection} [sortDirection]
         * @param {'historical' | 'live' | 'upcoming' | 'started'} [liveStatus]
         * @param {string} [parentCategoryId]
         * @param {string} [currency]
         * @param {boolean} [onHomepage]
         * @param {Array<string>} [categoryIds]
         * @param {string} [eventId]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {number} [maxNumberOfProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsOverviewGet: (xPlatformKey, sortBy, sortDirection, liveStatus, parentCategoryId, currency, onHomepage, categoryIds, eventId, pageSize, offset, maxNumberOfProducts, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2EventsOverviewGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/events-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sort_direction'] = sortDirection;
            }
            if (liveStatus !== undefined) {
                localVarQueryParameter['live_status'] = liveStatus;
            }
            if (parentCategoryId !== undefined) {
                localVarQueryParameter['parent_category_id'] = parentCategoryId;
            }
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            if (onHomepage !== undefined) {
                localVarQueryParameter['on_homepage'] = onHomepage;
            }
            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (maxNumberOfProducts !== undefined) {
                localVarQueryParameter['max_number_of_products'] = maxNumberOfProducts;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * EventsOverviewApi - functional programming interface
 * @export
 */
export const EventsOverviewApiFp = function (configuration) {
    const localVarAxiosParamCreator = EventsOverviewApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {DateSortAttribute} [sortBy]
         * @param {DateSortDirection} [sortDirection]
         * @param {'historical' | 'live' | 'upcoming' | 'started'} [liveStatus]
         * @param {string} [parentCategoryId]
         * @param {string} [currency]
         * @param {boolean} [onHomepage]
         * @param {Array<string>} [categoryIds]
         * @param {string} [eventId]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {number} [maxNumberOfProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsOverviewGet(xPlatformKey, sortBy, sortDirection, liveStatus, parentCategoryId, currency, onHomepage, categoryIds, eventId, pageSize, offset, maxNumberOfProducts, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2EventsOverviewGet(xPlatformKey, sortBy, sortDirection, liveStatus, parentCategoryId, currency, onHomepage, categoryIds, eventId, pageSize, offset, maxNumberOfProducts, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * EventsOverviewApi - factory interface
 * @export
 */
export const EventsOverviewApiFactory = function (configuration, basePath, axios) {
    const localVarFp = EventsOverviewApiFp(configuration);
    return {
        /**
         *
         * @param {EventsOverviewApiV2EventsOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2EventsOverviewGet(requestParameters, options) {
            return localVarFp.v2EventsOverviewGet(requestParameters.xPlatformKey, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.liveStatus, requestParameters.parentCategoryId, requestParameters.currency, requestParameters.onHomepage, requestParameters.categoryIds, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.maxNumberOfProducts, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * EventsOverviewApi - object-oriented interface
 * @export
 * @class EventsOverviewApi
 * @extends {BaseAPI}
 */
export class EventsOverviewApi extends BaseAPI {
    /**
     *
     * @param {EventsOverviewApiV2EventsOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsOverviewApi
     */
    v2EventsOverviewGet(requestParameters, options) {
        return EventsOverviewApiFp(this.configuration).v2EventsOverviewGet(requestParameters.xPlatformKey, requestParameters.sortBy, requestParameters.sortDirection, requestParameters.liveStatus, requestParameters.parentCategoryId, requestParameters.currency, requestParameters.onHomepage, requestParameters.categoryIds, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.maxNumberOfProducts, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FilterApi - axios parameter creator
 * @export
 */
export const FilterApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the filters for events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterEventsGet: (xPlatformKey, searchTerm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterEventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/filter/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductListingsFavouritesGet: (xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterProductListingsFavouritesGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/filter/product-listings/favourites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the filters for products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId]
         * @param {string} [searchTerm]
         * @param {string} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductsGet: (xPlatformKey, eventId, searchTerm, categoryId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2FilterProductsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/filter/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (categoryId !== undefined) {
                localVarQueryParameter['category_id'] = categoryId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FilterApi - functional programming interface
 * @export
 */
export const FilterApiFp = function (configuration) {
    const localVarAxiosParamCreator = FilterApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the filters for events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterEventsGet(xPlatformKey, searchTerm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2FilterEventsGet(xPlatformKey, searchTerm, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductListingsFavouritesGet(xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2FilterProductListingsFavouritesGet(xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the filters for products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId]
         * @param {string} [searchTerm]
         * @param {string} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductsGet(xPlatformKey, eventId, searchTerm, categoryId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2FilterProductsGet(xPlatformKey, eventId, searchTerm, categoryId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FilterApi - factory interface
 * @export
 */
export const FilterApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FilterApiFp(configuration);
    return {
        /**
         *
         * @summary Get the filters for events
         * @param {FilterApiV2FilterEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterEventsGet(requestParameters, options) {
            return localVarFp.v2FilterEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {FilterApiV2FilterProductListingsFavouritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductListingsFavouritesGet(requestParameters, options) {
            return localVarFp.v2FilterProductListingsFavouritesGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the filters for products
         * @param {FilterApiV2FilterProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FilterProductsGet(requestParameters, options) {
            return localVarFp.v2FilterProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.searchTerm, requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FilterApi - object-oriented interface
 * @export
 * @class FilterApi
 * @extends {BaseAPI}
 */
export class FilterApi extends BaseAPI {
    /**
     *
     * @summary Get the filters for events
     * @param {FilterApiV2FilterEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    v2FilterEventsGet(requestParameters, options) {
        return FilterApiFp(this.configuration).v2FilterEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {FilterApiV2FilterProductListingsFavouritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    v2FilterProductListingsFavouritesGet(requestParameters, options) {
        return FilterApiFp(this.configuration).v2FilterProductListingsFavouritesGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the filters for products
     * @param {FilterApiV2FilterProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilterApi
     */
    v2FilterProductsGet(requestParameters, options) {
        return FilterApiFp(this.configuration).v2FilterProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.searchTerm, requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * FramePreviewApi - axios parameter creator
 * @export
 */
export const FramePreviewApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Search frame previews by order id
         * @param {string} orderId
         * @param {string} [currency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FramePreviewsExternalReferenceOrderIdGet: (orderId, currency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2FramePreviewsExternalReferenceOrderIdGet', 'orderId', orderId);
            const localVarPath = `/v2/frame-previews/external-reference/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FramePreviewApi - functional programming interface
 * @export
 */
export const FramePreviewApiFp = function (configuration) {
    const localVarAxiosParamCreator = FramePreviewApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Search frame previews by order id
         * @param {string} orderId
         * @param {string} [currency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FramePreviewsExternalReferenceOrderIdGet(orderId, currency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2FramePreviewsExternalReferenceOrderIdGet(orderId, currency, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FramePreviewApi - factory interface
 * @export
 */
export const FramePreviewApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FramePreviewApiFp(configuration);
    return {
        /**
         *
         * @summary Search frame previews by order id
         * @param {FramePreviewApiV2FramePreviewsExternalReferenceOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2FramePreviewsExternalReferenceOrderIdGet(requestParameters, options) {
            return localVarFp.v2FramePreviewsExternalReferenceOrderIdGet(requestParameters.orderId, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FramePreviewApi - object-oriented interface
 * @export
 * @class FramePreviewApi
 * @extends {BaseAPI}
 */
export class FramePreviewApi extends BaseAPI {
    /**
     *
     * @summary Search frame previews by order id
     * @param {FramePreviewApiV2FramePreviewsExternalReferenceOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FramePreviewApi
     */
    v2FramePreviewsExternalReferenceOrderIdGet(requestParameters, options) {
        return FramePreviewApiFp(this.configuration).v2FramePreviewsExternalReferenceOrderIdGet(requestParameters.orderId, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * GiveawayApi - axios parameter creator
 * @export
 */
export const GiveawayApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Registers the user to the giveaway if not registered
         * @param {string} slug
         * @param {V2GiveawaysSlugPostRequest} [v2GiveawaysSlugPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GiveawaysSlugPost: (slug, v2GiveawaysSlugPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('v2GiveawaysSlugPost', 'slug', slug);
            const localVarPath = `/v2/giveaways/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2GiveawaysSlugPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * GiveawayApi - functional programming interface
 * @export
 */
export const GiveawayApiFp = function (configuration) {
    const localVarAxiosParamCreator = GiveawayApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Registers the user to the giveaway if not registered
         * @param {string} slug
         * @param {V2GiveawaysSlugPostRequest} [v2GiveawaysSlugPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GiveawaysSlugPost(slug, v2GiveawaysSlugPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GiveawaysSlugPost(slug, v2GiveawaysSlugPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * GiveawayApi - factory interface
 * @export
 */
export const GiveawayApiFactory = function (configuration, basePath, axios) {
    const localVarFp = GiveawayApiFp(configuration);
    return {
        /**
         *
         * @summary Registers the user to the giveaway if not registered
         * @param {GiveawayApiV2GiveawaysSlugPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GiveawaysSlugPost(requestParameters, options) {
            return localVarFp.v2GiveawaysSlugPost(requestParameters.slug, requestParameters.v2GiveawaysSlugPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GiveawayApi - object-oriented interface
 * @export
 * @class GiveawayApi
 * @extends {BaseAPI}
 */
export class GiveawayApi extends BaseAPI {
    /**
     *
     * @summary Registers the user to the giveaway if not registered
     * @param {GiveawayApiV2GiveawaysSlugPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiveawayApi
     */
    v2GiveawaysSlugPost(requestParameters, options) {
        return GiveawayApiFp(this.configuration).v2GiveawaysSlugPost(requestParameters.slug, requestParameters.v2GiveawaysSlugPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * IdentityProvidersApi - axios parameter creator
 * @export
 */
export const IdentityProvidersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersGet: (offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary OAuth2.0 /authorize endpoint. Usually the first call that is made in the Verification Code flow.  This endpoint proxies the call to a known External Identity provider and adds PKCE parameters to it
         * @param {string} providerSlug
         * @param {string} [state]
         * @param {string} [redirectUri]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugAuthorizeGet: (providerSlug, state, redirectUri, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('v2ProvidersProviderSlugAuthorizeGet', 'providerSlug', providerSlug);
            const localVarPath = `/v2/providers/{providerSlug}/authorize`
                .replace(`{${"providerSlug"}}`, encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Redirect url that we need to snoop the code from the response. We use the code in the /token endpoint so we know what session this token call relates to
         * @param {string} providerSlug
         * @param {string} [code]
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugCodeRedirectGet: (providerSlug, code, state, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('v2ProvidersProviderSlugCodeRedirectGet', 'providerSlug', providerSlug);
            const localVarPath = `/v2/providers/{providerSlug}/code-redirect`
                .replace(`{${"providerSlug"}}`, encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary OAuth2.0 token endpoint that proxies to a known external Identity Provider, and adds PKCE security layer to it.
         * @param {string} providerSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugTokenPost: (providerSlug, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'providerSlug' is not null or undefined
            assertParamExists('v2ProvidersProviderSlugTokenPost', 'providerSlug', providerSlug);
            const localVarPath = `/v2/providers/{providerSlug}/token`
                .replace(`{${"providerSlug"}}`, encodeURIComponent(String(providerSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * IdentityProvidersApi - functional programming interface
 * @export
 */
export const IdentityProvidersApiFp = function (configuration) {
    const localVarAxiosParamCreator = IdentityProvidersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersGet(offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProvidersGet(offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary OAuth2.0 /authorize endpoint. Usually the first call that is made in the Verification Code flow.  This endpoint proxies the call to a known External Identity provider and adds PKCE parameters to it
         * @param {string} providerSlug
         * @param {string} [state]
         * @param {string} [redirectUri]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugAuthorizeGet(providerSlug, state, redirectUri, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProvidersProviderSlugAuthorizeGet(providerSlug, state, redirectUri, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Redirect url that we need to snoop the code from the response. We use the code in the /token endpoint so we know what session this token call relates to
         * @param {string} providerSlug
         * @param {string} [code]
         * @param {string} [state]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugCodeRedirectGet(providerSlug, code, state, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProvidersProviderSlugCodeRedirectGet(providerSlug, code, state, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary OAuth2.0 token endpoint that proxies to a known external Identity Provider, and adds PKCE security layer to it.
         * @param {string} providerSlug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugTokenPost(providerSlug, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProvidersProviderSlugTokenPost(providerSlug, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * IdentityProvidersApi - factory interface
 * @export
 */
export const IdentityProvidersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = IdentityProvidersApiFp(configuration);
    return {
        /**
         *
         * @param {IdentityProvidersApiV2ProvidersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersGet(requestParameters = {}, options) {
            return localVarFp.v2ProvidersGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary OAuth2.0 /authorize endpoint. Usually the first call that is made in the Verification Code flow.  This endpoint proxies the call to a known External Identity provider and adds PKCE parameters to it
         * @param {IdentityProvidersApiV2ProvidersProviderSlugAuthorizeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugAuthorizeGet(requestParameters, options) {
            return localVarFp.v2ProvidersProviderSlugAuthorizeGet(requestParameters.providerSlug, requestParameters.state, requestParameters.redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Redirect url that we need to snoop the code from the response. We use the code in the /token endpoint so we know what session this token call relates to
         * @param {IdentityProvidersApiV2ProvidersProviderSlugCodeRedirectGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugCodeRedirectGet(requestParameters, options) {
            return localVarFp.v2ProvidersProviderSlugCodeRedirectGet(requestParameters.providerSlug, requestParameters.code, requestParameters.state, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary OAuth2.0 token endpoint that proxies to a known external Identity Provider, and adds PKCE security layer to it.
         * @param {IdentityProvidersApiV2ProvidersProviderSlugTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProvidersProviderSlugTokenPost(requestParameters, options) {
            return localVarFp.v2ProvidersProviderSlugTokenPost(requestParameters.providerSlug, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * IdentityProvidersApi - object-oriented interface
 * @export
 * @class IdentityProvidersApi
 * @extends {BaseAPI}
 */
export class IdentityProvidersApi extends BaseAPI {
    /**
     *
     * @param {IdentityProvidersApiV2ProvidersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    v2ProvidersGet(requestParameters = {}, options) {
        return IdentityProvidersApiFp(this.configuration).v2ProvidersGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary OAuth2.0 /authorize endpoint. Usually the first call that is made in the Verification Code flow.  This endpoint proxies the call to a known External Identity provider and adds PKCE parameters to it
     * @param {IdentityProvidersApiV2ProvidersProviderSlugAuthorizeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    v2ProvidersProviderSlugAuthorizeGet(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration).v2ProvidersProviderSlugAuthorizeGet(requestParameters.providerSlug, requestParameters.state, requestParameters.redirectUri, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Redirect url that we need to snoop the code from the response. We use the code in the /token endpoint so we know what session this token call relates to
     * @param {IdentityProvidersApiV2ProvidersProviderSlugCodeRedirectGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    v2ProvidersProviderSlugCodeRedirectGet(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration).v2ProvidersProviderSlugCodeRedirectGet(requestParameters.providerSlug, requestParameters.code, requestParameters.state, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary OAuth2.0 token endpoint that proxies to a known external Identity Provider, and adds PKCE security layer to it.
     * @param {IdentityProvidersApiV2ProvidersProviderSlugTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityProvidersApi
     */
    v2ProvidersProviderSlugTokenPost(requestParameters, options) {
        return IdentityProvidersApiFp(this.configuration).v2ProvidersProviderSlugTokenPost(requestParameters.providerSlug, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the customer details for the currently authenticated customer
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountGet: (xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeAccountGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update customer details for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {V2MeAccountPatchRequest} [v2MeAccountPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountPatch: (xPlatformKey, v2MeAccountPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeAccountPatch', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeAccountPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidderGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/bidder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Bids for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {'all' | 'live' | 'won' | 'closed'} [publicBidsStatusFilters]
         * @param {boolean} [highestBid]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Date} [createdAtEq]
         * @param {Date} [createdAtNot]
         * @param {Date} [createdAtGt]
         * @param {Date} [createdAtLt]
         * @param {Date} [createdAtGte]
         * @param {Date} [createdAtLte]
         * @param {boolean} [createdAtIsNull]
         * @param {boolean} [createdAtIsNotNull]
         * @param {'and' | 'or'} [createdAtCombineWith]
         * @param {Date} [productEndDateMin]
         * @param {Date} [productEndDateMax]
         * @param {Date} [productEndDateEq]
         * @param {Date} [productEndDateNot]
         * @param {Date} [productEndDateGt]
         * @param {Date} [productEndDateLt]
         * @param {Date} [productEndDateGte]
         * @param {Date} [productEndDateLte]
         * @param {boolean} [productEndDateIsNull]
         * @param {boolean} [productEndDateIsNotNull]
         * @param {'and' | 'or'} [productEndDateCombineWith]
         * @param {'and' | 'or'} [productCombineWith]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsGet: (xPlatformKey, publicBidsStatusFilters, highestBid, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, createdAtCombineWith, productEndDateMin, productEndDateMax, productEndDateEq, productEndDateNot, productEndDateGt, productEndDateLt, productEndDateGte, productEndDateLte, productEndDateIsNull, productEndDateIsNotNull, productEndDateCombineWith, productCombineWith, perPage, page, pageSize, offset, sortBy, sort, combineWith, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeBidsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/bids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (publicBidsStatusFilters !== undefined) {
                localVarQueryParameter['public_bids_status_filters'] = publicBidsStatusFilters;
            }
            if (highestBid !== undefined) {
                localVarQueryParameter['highest_bid'] = highestBid;
            }
            if (createdAtMin !== undefined) {
                localVarQueryParameter['created_at.min'] = (createdAtMin instanceof Date) ?
                    createdAtMin.toISOString() :
                    createdAtMin;
            }
            if (createdAtMax !== undefined) {
                localVarQueryParameter['created_at.max'] = (createdAtMax instanceof Date) ?
                    createdAtMax.toISOString() :
                    createdAtMax;
            }
            if (createdAtEq !== undefined) {
                localVarQueryParameter['created_at.eq'] = (createdAtEq instanceof Date) ?
                    createdAtEq.toISOString() :
                    createdAtEq;
            }
            if (createdAtNot !== undefined) {
                localVarQueryParameter['created_at.not'] = (createdAtNot instanceof Date) ?
                    createdAtNot.toISOString() :
                    createdAtNot;
            }
            if (createdAtGt !== undefined) {
                localVarQueryParameter['created_at.gt'] = (createdAtGt instanceof Date) ?
                    createdAtGt.toISOString() :
                    createdAtGt;
            }
            if (createdAtLt !== undefined) {
                localVarQueryParameter['created_at.lt'] = (createdAtLt instanceof Date) ?
                    createdAtLt.toISOString() :
                    createdAtLt;
            }
            if (createdAtGte !== undefined) {
                localVarQueryParameter['created_at.gte'] = (createdAtGte instanceof Date) ?
                    createdAtGte.toISOString() :
                    createdAtGte;
            }
            if (createdAtLte !== undefined) {
                localVarQueryParameter['created_at.lte'] = (createdAtLte instanceof Date) ?
                    createdAtLte.toISOString() :
                    createdAtLte;
            }
            if (createdAtIsNull !== undefined) {
                localVarQueryParameter['created_at.is_null'] = createdAtIsNull;
            }
            if (createdAtIsNotNull !== undefined) {
                localVarQueryParameter['created_at.is_not_null'] = createdAtIsNotNull;
            }
            if (createdAtCombineWith !== undefined) {
                localVarQueryParameter['created_at.combine_with'] = createdAtCombineWith;
            }
            if (productEndDateMin !== undefined) {
                localVarQueryParameter['product.end_date.min'] = (productEndDateMin instanceof Date) ?
                    productEndDateMin.toISOString() :
                    productEndDateMin;
            }
            if (productEndDateMax !== undefined) {
                localVarQueryParameter['product.end_date.max'] = (productEndDateMax instanceof Date) ?
                    productEndDateMax.toISOString() :
                    productEndDateMax;
            }
            if (productEndDateEq !== undefined) {
                localVarQueryParameter['product.end_date.eq'] = (productEndDateEq instanceof Date) ?
                    productEndDateEq.toISOString() :
                    productEndDateEq;
            }
            if (productEndDateNot !== undefined) {
                localVarQueryParameter['product.end_date.not'] = (productEndDateNot instanceof Date) ?
                    productEndDateNot.toISOString() :
                    productEndDateNot;
            }
            if (productEndDateGt !== undefined) {
                localVarQueryParameter['product.end_date.gt'] = (productEndDateGt instanceof Date) ?
                    productEndDateGt.toISOString() :
                    productEndDateGt;
            }
            if (productEndDateLt !== undefined) {
                localVarQueryParameter['product.end_date.lt'] = (productEndDateLt instanceof Date) ?
                    productEndDateLt.toISOString() :
                    productEndDateLt;
            }
            if (productEndDateGte !== undefined) {
                localVarQueryParameter['product.end_date.gte'] = (productEndDateGte instanceof Date) ?
                    productEndDateGte.toISOString() :
                    productEndDateGte;
            }
            if (productEndDateLte !== undefined) {
                localVarQueryParameter['product.end_date.lte'] = (productEndDateLte instanceof Date) ?
                    productEndDateLte.toISOString() :
                    productEndDateLte;
            }
            if (productEndDateIsNull !== undefined) {
                localVarQueryParameter['product.end_date.is_null'] = productEndDateIsNull;
            }
            if (productEndDateIsNotNull !== undefined) {
                localVarQueryParameter['product.end_date.is_not_null'] = productEndDateIsNotNull;
            }
            if (productEndDateCombineWith !== undefined) {
                localVarQueryParameter['product.end_date.combine_with'] = productEndDateCombineWith;
            }
            if (productCombineWith !== undefined) {
                localVarQueryParameter['product.combine_with'] = productCombineWith;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Get the set of unique products on which the user placed bids
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsProductsGet: (xPlatformKey, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeBidsProductsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/bids/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get information about bundling non shipped orders for the user
         * @param {string} [currencyCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBundlingGet: (currencyCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/bundling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDelete: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get information about the currently logged in user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MeGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Orders for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<OrderPaymentStatus>} [statuses] One or more order statuses to filter on.
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Date} [createdAtEq]
         * @param {Date} [createdAtNot]
         * @param {Date} [createdAtGt]
         * @param {Date} [createdAtLt]
         * @param {Date} [createdAtGte]
         * @param {Date} [createdAtLte]
         * @param {boolean} [createdAtIsNull]
         * @param {boolean} [createdAtIsNotNull]
         * @param {Date} [shippedAtMin]
         * @param {Date} [shippedAtMax]
         * @param {Date} [shippedAtEq]
         * @param {Date} [shippedAtNot]
         * @param {Date} [shippedAtGt]
         * @param {Date} [shippedAtLt]
         * @param {Date} [shippedAtGte]
         * @param {Date} [shippedAtLte]
         * @param {boolean} [shippedAtIsNull]
         * @param {boolean} [shippedAtIsNotNull]
         * @param {Date} [datePaidMin]
         * @param {Date} [datePaidMax]
         * @param {Date} [datePaidEq]
         * @param {Date} [datePaidNot]
         * @param {Date} [datePaidGt]
         * @param {Date} [datePaidLt]
         * @param {Date} [datePaidGte]
         * @param {Date} [datePaidLte]
         * @param {boolean} [datePaidIsNull]
         * @param {boolean} [datePaidIsNotNull]
         * @param {boolean} [isRecent] Filters for orders created the last 30 days and not shipped or orders shipped the last 7 days  The orders either need to have the status paid, processing or open, framed shirts are excluded
         * @param {FramingStatus} [framingStatusStatus]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {'DateCreated' | 'DateShipped' | 'DatePaid'} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeOrdersGet: (xPlatformKey, statuses, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, shippedAtMin, shippedAtMax, shippedAtEq, shippedAtNot, shippedAtGt, shippedAtLt, shippedAtGte, shippedAtLte, shippedAtIsNull, shippedAtIsNotNull, datePaidMin, datePaidMax, datePaidEq, datePaidNot, datePaidGt, datePaidLt, datePaidGte, datePaidLte, datePaidIsNull, datePaidIsNotNull, isRecent, framingStatusStatus, perPage, page, pageSize, offset, sortBy, sort, combineWith, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeOrdersGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (createdAtMin !== undefined) {
                localVarQueryParameter['created_at.min'] = (createdAtMin instanceof Date) ?
                    createdAtMin.toISOString() :
                    createdAtMin;
            }
            if (createdAtMax !== undefined) {
                localVarQueryParameter['created_at.max'] = (createdAtMax instanceof Date) ?
                    createdAtMax.toISOString() :
                    createdAtMax;
            }
            if (createdAtEq !== undefined) {
                localVarQueryParameter['created_at.eq'] = (createdAtEq instanceof Date) ?
                    createdAtEq.toISOString() :
                    createdAtEq;
            }
            if (createdAtNot !== undefined) {
                localVarQueryParameter['created_at.not'] = (createdAtNot instanceof Date) ?
                    createdAtNot.toISOString() :
                    createdAtNot;
            }
            if (createdAtGt !== undefined) {
                localVarQueryParameter['created_at.gt'] = (createdAtGt instanceof Date) ?
                    createdAtGt.toISOString() :
                    createdAtGt;
            }
            if (createdAtLt !== undefined) {
                localVarQueryParameter['created_at.lt'] = (createdAtLt instanceof Date) ?
                    createdAtLt.toISOString() :
                    createdAtLt;
            }
            if (createdAtGte !== undefined) {
                localVarQueryParameter['created_at.gte'] = (createdAtGte instanceof Date) ?
                    createdAtGte.toISOString() :
                    createdAtGte;
            }
            if (createdAtLte !== undefined) {
                localVarQueryParameter['created_at.lte'] = (createdAtLte instanceof Date) ?
                    createdAtLte.toISOString() :
                    createdAtLte;
            }
            if (createdAtIsNull !== undefined) {
                localVarQueryParameter['created_at.is_null'] = createdAtIsNull;
            }
            if (createdAtIsNotNull !== undefined) {
                localVarQueryParameter['created_at.is_not_null'] = createdAtIsNotNull;
            }
            if (shippedAtMin !== undefined) {
                localVarQueryParameter['shipped_at.min'] = (shippedAtMin instanceof Date) ?
                    shippedAtMin.toISOString() :
                    shippedAtMin;
            }
            if (shippedAtMax !== undefined) {
                localVarQueryParameter['shipped_at.max'] = (shippedAtMax instanceof Date) ?
                    shippedAtMax.toISOString() :
                    shippedAtMax;
            }
            if (shippedAtEq !== undefined) {
                localVarQueryParameter['shipped_at.eq'] = (shippedAtEq instanceof Date) ?
                    shippedAtEq.toISOString() :
                    shippedAtEq;
            }
            if (shippedAtNot !== undefined) {
                localVarQueryParameter['shipped_at.not'] = (shippedAtNot instanceof Date) ?
                    shippedAtNot.toISOString() :
                    shippedAtNot;
            }
            if (shippedAtGt !== undefined) {
                localVarQueryParameter['shipped_at.gt'] = (shippedAtGt instanceof Date) ?
                    shippedAtGt.toISOString() :
                    shippedAtGt;
            }
            if (shippedAtLt !== undefined) {
                localVarQueryParameter['shipped_at.lt'] = (shippedAtLt instanceof Date) ?
                    shippedAtLt.toISOString() :
                    shippedAtLt;
            }
            if (shippedAtGte !== undefined) {
                localVarQueryParameter['shipped_at.gte'] = (shippedAtGte instanceof Date) ?
                    shippedAtGte.toISOString() :
                    shippedAtGte;
            }
            if (shippedAtLte !== undefined) {
                localVarQueryParameter['shipped_at.lte'] = (shippedAtLte instanceof Date) ?
                    shippedAtLte.toISOString() :
                    shippedAtLte;
            }
            if (shippedAtIsNull !== undefined) {
                localVarQueryParameter['shipped_at.is_null'] = shippedAtIsNull;
            }
            if (shippedAtIsNotNull !== undefined) {
                localVarQueryParameter['shipped_at.is_not_null'] = shippedAtIsNotNull;
            }
            if (datePaidMin !== undefined) {
                localVarQueryParameter['date_paid.min'] = (datePaidMin instanceof Date) ?
                    datePaidMin.toISOString() :
                    datePaidMin;
            }
            if (datePaidMax !== undefined) {
                localVarQueryParameter['date_paid.max'] = (datePaidMax instanceof Date) ?
                    datePaidMax.toISOString() :
                    datePaidMax;
            }
            if (datePaidEq !== undefined) {
                localVarQueryParameter['date_paid.eq'] = (datePaidEq instanceof Date) ?
                    datePaidEq.toISOString() :
                    datePaidEq;
            }
            if (datePaidNot !== undefined) {
                localVarQueryParameter['date_paid.not'] = (datePaidNot instanceof Date) ?
                    datePaidNot.toISOString() :
                    datePaidNot;
            }
            if (datePaidGt !== undefined) {
                localVarQueryParameter['date_paid.gt'] = (datePaidGt instanceof Date) ?
                    datePaidGt.toISOString() :
                    datePaidGt;
            }
            if (datePaidLt !== undefined) {
                localVarQueryParameter['date_paid.lt'] = (datePaidLt instanceof Date) ?
                    datePaidLt.toISOString() :
                    datePaidLt;
            }
            if (datePaidGte !== undefined) {
                localVarQueryParameter['date_paid.gte'] = (datePaidGte instanceof Date) ?
                    datePaidGte.toISOString() :
                    datePaidGte;
            }
            if (datePaidLte !== undefined) {
                localVarQueryParameter['date_paid.lte'] = (datePaidLte instanceof Date) ?
                    datePaidLte.toISOString() :
                    datePaidLte;
            }
            if (datePaidIsNull !== undefined) {
                localVarQueryParameter['date_paid.is_null'] = datePaidIsNull;
            }
            if (datePaidIsNotNull !== undefined) {
                localVarQueryParameter['date_paid.is_not_null'] = datePaidIsNotNull;
            }
            if (isRecent !== undefined) {
                localVarQueryParameter['is_recent'] = isRecent;
            }
            if (framingStatusStatus !== undefined) {
                localVarQueryParameter['framing_status.status'] = framingStatusStatus;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user profile settings
         * @param {V2MePatchRequest} [v2MePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePatch: (v2MePatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Attempts to set a phone number for the requesting user. If the requesting user already has  a verified number, this method fails with a 403 - Forbidden status code. If the requesting  user has a phone number saved which is not yet verified, then updates to the phone number  are allowed, and a new SMS message with verification code is sent.
         * @summary Set a phone number for the requesting user
         * @param {V2MePhonePutRequest} [v2MePhonePutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePhonePut: (v2MePhonePutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePhonePutRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the customer details for the currently authenticated customer
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountGet(xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAccountGet(xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update customer details for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {V2MeAccountPatchRequest} [v2MeAccountPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountPatch(xPlatformKey, v2MeAccountPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAccountPatch(xPlatformKey, v2MeAccountPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidderGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeBidderGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List Bids for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {'all' | 'live' | 'won' | 'closed'} [publicBidsStatusFilters]
         * @param {boolean} [highestBid]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Date} [createdAtEq]
         * @param {Date} [createdAtNot]
         * @param {Date} [createdAtGt]
         * @param {Date} [createdAtLt]
         * @param {Date} [createdAtGte]
         * @param {Date} [createdAtLte]
         * @param {boolean} [createdAtIsNull]
         * @param {boolean} [createdAtIsNotNull]
         * @param {'and' | 'or'} [createdAtCombineWith]
         * @param {Date} [productEndDateMin]
         * @param {Date} [productEndDateMax]
         * @param {Date} [productEndDateEq]
         * @param {Date} [productEndDateNot]
         * @param {Date} [productEndDateGt]
         * @param {Date} [productEndDateLt]
         * @param {Date} [productEndDateGte]
         * @param {Date} [productEndDateLte]
         * @param {boolean} [productEndDateIsNull]
         * @param {boolean} [productEndDateIsNotNull]
         * @param {'and' | 'or'} [productEndDateCombineWith]
         * @param {'and' | 'or'} [productCombineWith]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsGet(xPlatformKey, publicBidsStatusFilters, highestBid, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, createdAtCombineWith, productEndDateMin, productEndDateMax, productEndDateEq, productEndDateNot, productEndDateGt, productEndDateLt, productEndDateGte, productEndDateLte, productEndDateIsNull, productEndDateIsNotNull, productEndDateCombineWith, productCombineWith, perPage, page, pageSize, offset, sortBy, sort, combineWith, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeBidsGet(xPlatformKey, publicBidsStatusFilters, highestBid, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, createdAtCombineWith, productEndDateMin, productEndDateMax, productEndDateEq, productEndDateNot, productEndDateGt, productEndDateLt, productEndDateGte, productEndDateLte, productEndDateIsNull, productEndDateIsNotNull, productEndDateCombineWith, productCombineWith, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Get the set of unique products on which the user placed bids
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsProductsGet(xPlatformKey, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeBidsProductsGet(xPlatformKey, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get information about bundling non shipped orders for the user
         * @param {string} [currencyCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBundlingGet(currencyCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeBundlingGet(currencyCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDelete(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeDelete(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get information about the currently logged in user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MeGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List Orders for the currently authenticated user
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<OrderPaymentStatus>} [statuses] One or more order statuses to filter on.
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Date} [createdAtEq]
         * @param {Date} [createdAtNot]
         * @param {Date} [createdAtGt]
         * @param {Date} [createdAtLt]
         * @param {Date} [createdAtGte]
         * @param {Date} [createdAtLte]
         * @param {boolean} [createdAtIsNull]
         * @param {boolean} [createdAtIsNotNull]
         * @param {Date} [shippedAtMin]
         * @param {Date} [shippedAtMax]
         * @param {Date} [shippedAtEq]
         * @param {Date} [shippedAtNot]
         * @param {Date} [shippedAtGt]
         * @param {Date} [shippedAtLt]
         * @param {Date} [shippedAtGte]
         * @param {Date} [shippedAtLte]
         * @param {boolean} [shippedAtIsNull]
         * @param {boolean} [shippedAtIsNotNull]
         * @param {Date} [datePaidMin]
         * @param {Date} [datePaidMax]
         * @param {Date} [datePaidEq]
         * @param {Date} [datePaidNot]
         * @param {Date} [datePaidGt]
         * @param {Date} [datePaidLt]
         * @param {Date} [datePaidGte]
         * @param {Date} [datePaidLte]
         * @param {boolean} [datePaidIsNull]
         * @param {boolean} [datePaidIsNotNull]
         * @param {boolean} [isRecent] Filters for orders created the last 30 days and not shipped or orders shipped the last 7 days  The orders either need to have the status paid, processing or open, framed shirts are excluded
         * @param {FramingStatus} [framingStatusStatus]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {'DateCreated' | 'DateShipped' | 'DatePaid'} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeOrdersGet(xPlatformKey, statuses, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, shippedAtMin, shippedAtMax, shippedAtEq, shippedAtNot, shippedAtGt, shippedAtLt, shippedAtGte, shippedAtLte, shippedAtIsNull, shippedAtIsNotNull, datePaidMin, datePaidMax, datePaidEq, datePaidNot, datePaidGt, datePaidLt, datePaidGte, datePaidLte, datePaidIsNull, datePaidIsNotNull, isRecent, framingStatusStatus, perPage, page, pageSize, offset, sortBy, sort, combineWith, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeOrdersGet(xPlatformKey, statuses, createdAtMin, createdAtMax, createdAtEq, createdAtNot, createdAtGt, createdAtLt, createdAtGte, createdAtLte, createdAtIsNull, createdAtIsNotNull, shippedAtMin, shippedAtMax, shippedAtEq, shippedAtNot, shippedAtGt, shippedAtLt, shippedAtGte, shippedAtLte, shippedAtIsNull, shippedAtIsNotNull, datePaidMin, datePaidMax, datePaidEq, datePaidNot, datePaidGt, datePaidLt, datePaidGte, datePaidLte, datePaidIsNull, datePaidIsNotNull, isRecent, framingStatusStatus, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update user profile settings
         * @param {V2MePatchRequest} [v2MePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePatch(v2MePatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePatch(v2MePatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Attempts to set a phone number for the requesting user. If the requesting user already has  a verified number, this method fails with a 403 - Forbidden status code. If the requesting  user has a phone number saved which is not yet verified, then updates to the phone number  are allowed, and a new SMS message with verification code is sent.
         * @summary Set a phone number for the requesting user
         * @param {V2MePhonePutRequest} [v2MePhonePutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePhonePut(v2MePhonePutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePhonePut(v2MePhonePutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeApiFp(configuration);
    return {
        /**
         *
         * @summary Get the customer details for the currently authenticated customer
         * @param {MeApiV2MeAccountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountGet(requestParameters, options) {
            return localVarFp.v2MeAccountGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update customer details for the currently authenticated user
         * @param {MeApiV2MeAccountPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAccountPatch(requestParameters, options) {
            return localVarFp.v2MeAccountPatch(requestParameters.xPlatformKey, requestParameters.v2MeAccountPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Get the bidder associated with the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidderGet(options) {
            return localVarFp.v2MeBidderGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Bids for the currently authenticated user
         * @param {MeApiV2MeBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsGet(requestParameters, options) {
            return localVarFp.v2MeBidsGet(requestParameters.xPlatformKey, requestParameters.publicBidsStatusFilters, requestParameters.highestBid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.createdAtCombineWith, requestParameters.productEndDateMin, requestParameters.productEndDateMax, requestParameters.productEndDateEq, requestParameters.productEndDateNot, requestParameters.productEndDateGt, requestParameters.productEndDateLt, requestParameters.productEndDateGte, requestParameters.productEndDateLte, requestParameters.productEndDateIsNull, requestParameters.productEndDateIsNotNull, requestParameters.productEndDateCombineWith, requestParameters.productCombineWith, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Get the set of unique products on which the user placed bids
         * @param {MeApiV2MeBidsProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBidsProductsGet(requestParameters, options) {
            return localVarFp.v2MeBidsProductsGet(requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get information about bundling non shipped orders for the user
         * @param {MeApiV2MeBundlingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeBundlingGet(requestParameters = {}, options) {
            return localVarFp.v2MeBundlingGet(requestParameters.currencyCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDelete(options) {
            return localVarFp.v2MeDelete(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get information about the currently logged in user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MeGet(options) {
            return localVarFp.v2MeGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Orders for the currently authenticated user
         * @param {MeApiV2MeOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeOrdersGet(requestParameters, options) {
            return localVarFp.v2MeOrdersGet(requestParameters.xPlatformKey, requestParameters.statuses, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.shippedAtMin, requestParameters.shippedAtMax, requestParameters.shippedAtEq, requestParameters.shippedAtNot, requestParameters.shippedAtGt, requestParameters.shippedAtLt, requestParameters.shippedAtGte, requestParameters.shippedAtLte, requestParameters.shippedAtIsNull, requestParameters.shippedAtIsNotNull, requestParameters.datePaidMin, requestParameters.datePaidMax, requestParameters.datePaidEq, requestParameters.datePaidNot, requestParameters.datePaidGt, requestParameters.datePaidLt, requestParameters.datePaidGte, requestParameters.datePaidLte, requestParameters.datePaidIsNull, requestParameters.datePaidIsNotNull, requestParameters.isRecent, requestParameters.framingStatusStatus, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user profile settings
         * @param {MeApiV2MePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePatch(requestParameters = {}, options) {
            return localVarFp.v2MePatch(requestParameters.v2MePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Attempts to set a phone number for the requesting user. If the requesting user already has  a verified number, this method fails with a 403 - Forbidden status code. If the requesting  user has a phone number saved which is not yet verified, then updates to the phone number  are allowed, and a new SMS message with verification code is sent.
         * @summary Set a phone number for the requesting user
         * @param {MeApiV2MePhonePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePhonePut(requestParameters = {}, options) {
            return localVarFp.v2MePhonePut(requestParameters.v2MePhonePutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
    /**
     *
     * @summary Get the customer details for the currently authenticated customer
     * @param {MeApiV2MeAccountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeAccountGet(requestParameters, options) {
        return MeApiFp(this.configuration).v2MeAccountGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update customer details for the currently authenticated user
     * @param {MeApiV2MeAccountPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeAccountPatch(requestParameters, options) {
        return MeApiFp(this.configuration).v2MeAccountPatch(requestParameters.xPlatformKey, requestParameters.v2MeAccountPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Get the bidder associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeBidderGet(options) {
        return MeApiFp(this.configuration).v2MeBidderGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Bids for the currently authenticated user
     * @param {MeApiV2MeBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeBidsGet(requestParameters, options) {
        return MeApiFp(this.configuration).v2MeBidsGet(requestParameters.xPlatformKey, requestParameters.publicBidsStatusFilters, requestParameters.highestBid, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.createdAtCombineWith, requestParameters.productEndDateMin, requestParameters.productEndDateMax, requestParameters.productEndDateEq, requestParameters.productEndDateNot, requestParameters.productEndDateGt, requestParameters.productEndDateLt, requestParameters.productEndDateGte, requestParameters.productEndDateLte, requestParameters.productEndDateIsNull, requestParameters.productEndDateIsNotNull, requestParameters.productEndDateCombineWith, requestParameters.productCombineWith, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Get the set of unique products on which the user placed bids
     * @param {MeApiV2MeBidsProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeBidsProductsGet(requestParameters, options) {
        return MeApiFp(this.configuration).v2MeBidsProductsGet(requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get information about bundling non shipped orders for the user
     * @param {MeApiV2MeBundlingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeBundlingGet(requestParameters = {}, options) {
        return MeApiFp(this.configuration).v2MeBundlingGet(requestParameters.currencyCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete the currently logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeDelete(options) {
        return MeApiFp(this.configuration).v2MeDelete(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get information about the currently logged in user
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeGet(options) {
        return MeApiFp(this.configuration).v2MeGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Orders for the currently authenticated user
     * @param {MeApiV2MeOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MeOrdersGet(requestParameters, options) {
        return MeApiFp(this.configuration).v2MeOrdersGet(requestParameters.xPlatformKey, requestParameters.statuses, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdAtEq, requestParameters.createdAtNot, requestParameters.createdAtGt, requestParameters.createdAtLt, requestParameters.createdAtGte, requestParameters.createdAtLte, requestParameters.createdAtIsNull, requestParameters.createdAtIsNotNull, requestParameters.shippedAtMin, requestParameters.shippedAtMax, requestParameters.shippedAtEq, requestParameters.shippedAtNot, requestParameters.shippedAtGt, requestParameters.shippedAtLt, requestParameters.shippedAtGte, requestParameters.shippedAtLte, requestParameters.shippedAtIsNull, requestParameters.shippedAtIsNotNull, requestParameters.datePaidMin, requestParameters.datePaidMax, requestParameters.datePaidEq, requestParameters.datePaidNot, requestParameters.datePaidGt, requestParameters.datePaidLt, requestParameters.datePaidGte, requestParameters.datePaidLte, requestParameters.datePaidIsNull, requestParameters.datePaidIsNotNull, requestParameters.isRecent, requestParameters.framingStatusStatus, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user profile settings
     * @param {MeApiV2MePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MePatch(requestParameters = {}, options) {
        return MeApiFp(this.configuration).v2MePatch(requestParameters.v2MePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Attempts to set a phone number for the requesting user. If the requesting user already has  a verified number, this method fails with a 403 - Forbidden status code. If the requesting  user has a phone number saved which is not yet verified, then updates to the phone number  are allowed, and a new SMS message with verification code is sent.
     * @summary Set a phone number for the requesting user
     * @param {MeApiV2MePhonePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    v2MePhonePut(requestParameters = {}, options) {
        return MeApiFp(this.configuration).v2MePhonePut(requestParameters.v2MePhonePutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeAddressesApi - axios parameter creator
 * @export
 */
export const MeAddressesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {string} addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdDelete: (addressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('v2MeAddressesAddressIdDelete', 'addressId', addressId);
            const localVarPath = `/v2/me/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Edit an address of the currently authenticated user
         * @param {string} addressId
         * @param {V2MeAddressesAddressIdPatchRequest} [v2MeAddressesAddressIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdPatch: (addressId, v2MeAddressesAddressIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('v2MeAddressesAddressIdPatch', 'addressId', addressId);
            const localVarPath = `/v2/me/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeAddressesAddressIdPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the addresses of the currently authenticated user
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesGet: (offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {V2MeAddressesPostRequest} [v2MeAddressesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesPost: (v2MeAddressesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeAddressesPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeAddressesApi - functional programming interface
 * @export
 */
export const MeAddressesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeAddressesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {string} addressId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdDelete(addressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAddressesAddressIdDelete(addressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Edit an address of the currently authenticated user
         * @param {string} addressId
         * @param {V2MeAddressesAddressIdPatchRequest} [v2MeAddressesAddressIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdPatch(addressId, v2MeAddressesAddressIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAddressesAddressIdPatch(addressId, v2MeAddressesAddressIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the addresses of the currently authenticated user
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesGet(offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAddressesGet(offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {V2MeAddressesPostRequest} [v2MeAddressesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesPost(v2MeAddressesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeAddressesPost(v2MeAddressesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MeAddressesApi - factory interface
 * @export
 */
export const MeAddressesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeAddressesApiFp(configuration);
    return {
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {MeAddressesApiV2MeAddressesAddressIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdDelete(requestParameters, options) {
            return localVarFp.v2MeAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edit an address of the currently authenticated user
         * @param {MeAddressesApiV2MeAddressesAddressIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesAddressIdPatch(requestParameters, options) {
            return localVarFp.v2MeAddressesAddressIdPatch(requestParameters.addressId, requestParameters.v2MeAddressesAddressIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the addresses of the currently authenticated user
         * @param {MeAddressesApiV2MeAddressesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesGet(requestParameters = {}, options) {
            return localVarFp.v2MeAddressesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add an address to the currently authenticated user
         * @param {MeAddressesApiV2MeAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeAddressesPost(requestParameters = {}, options) {
            return localVarFp.v2MeAddressesPost(requestParameters.v2MeAddressesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeAddressesApi - object-oriented interface
 * @export
 * @class MeAddressesApi
 * @extends {BaseAPI}
 */
export class MeAddressesApi extends BaseAPI {
    /**
     *
     * @summary Add an address to the currently authenticated user
     * @param {MeAddressesApiV2MeAddressesAddressIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeAddressesApi
     */
    v2MeAddressesAddressIdDelete(requestParameters, options) {
        return MeAddressesApiFp(this.configuration).v2MeAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Edit an address of the currently authenticated user
     * @param {MeAddressesApiV2MeAddressesAddressIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeAddressesApi
     */
    v2MeAddressesAddressIdPatch(requestParameters, options) {
        return MeAddressesApiFp(this.configuration).v2MeAddressesAddressIdPatch(requestParameters.addressId, requestParameters.v2MeAddressesAddressIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the addresses of the currently authenticated user
     * @param {MeAddressesApiV2MeAddressesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeAddressesApi
     */
    v2MeAddressesGet(requestParameters = {}, options) {
        return MeAddressesApiFp(this.configuration).v2MeAddressesGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add an address to the currently authenticated user
     * @param {MeAddressesApiV2MeAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeAddressesApi
     */
    v2MeAddressesPost(requestParameters = {}, options) {
        return MeAddressesApiFp(this.configuration).v2MeAddressesPost(requestParameters.v2MeAddressesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeDetailsApi - axios parameter creator
 * @export
 */
export const MeDetailsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get te user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDetailsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeDetailsApi - functional programming interface
 * @export
 */
export const MeDetailsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeDetailsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get te user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDetailsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeDetailsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MeDetailsApi - factory interface
 * @export
 */
export const MeDetailsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeDetailsApiFp(configuration);
    return {
        /**
         *
         * @summary Get te user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeDetailsGet(options) {
            return localVarFp.v2MeDetailsGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeDetailsApi - object-oriented interface
 * @export
 * @class MeDetailsApi
 * @extends {BaseAPI}
 */
export class MeDetailsApi extends BaseAPI {
    /**
     *
     * @summary Get te user\'s details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeDetailsApi
     */
    v2MeDetailsGet(options) {
        return MeDetailsApiFp(this.configuration).v2MeDetailsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MePaymentVerificationsApi - axios parameter creator
 * @export
 */
export const MePaymentVerificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the payment methods for payment verification
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentMethodsGet: (xPlatformKey, localeCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MeVerificationsPaymentMethodsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/verifications/payment/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (localeCode !== undefined) {
                localVarQueryParameter['locale_code'] = localeCode;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Starts a payment verification session with the payment provider
         * @param {V2MeVerificationsPaymentPostRequest} [v2MeVerificationsPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentPost: (v2MeVerificationsPaymentPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeVerificationsPaymentPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MePaymentVerificationsApi - functional programming interface
 * @export
 */
export const MePaymentVerificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MePaymentVerificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the payment methods for payment verification
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentMethodsGet(xPlatformKey, localeCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsPaymentMethodsGet(xPlatformKey, localeCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Starts a payment verification session with the payment provider
         * @param {V2MeVerificationsPaymentPostRequest} [v2MeVerificationsPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentPost(v2MeVerificationsPaymentPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsPaymentPost(v2MeVerificationsPaymentPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MePaymentVerificationsApi - factory interface
 * @export
 */
export const MePaymentVerificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MePaymentVerificationsApiFp(configuration);
    return {
        /**
         *
         * @summary Get the payment methods for payment verification
         * @param {MePaymentVerificationsApiV2MeVerificationsPaymentMethodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentMethodsGet(requestParameters, options) {
            return localVarFp.v2MeVerificationsPaymentMethodsGet(requestParameters.xPlatformKey, requestParameters.localeCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Starts a payment verification session with the payment provider
         * @param {MePaymentVerificationsApiV2MeVerificationsPaymentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPaymentPost(requestParameters = {}, options) {
            return localVarFp.v2MeVerificationsPaymentPost(requestParameters.v2MeVerificationsPaymentPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MePaymentVerificationsApi - object-oriented interface
 * @export
 * @class MePaymentVerificationsApi
 * @extends {BaseAPI}
 */
export class MePaymentVerificationsApi extends BaseAPI {
    /**
     *
     * @summary Get the payment methods for payment verification
     * @param {MePaymentVerificationsApiV2MeVerificationsPaymentMethodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MePaymentVerificationsApi
     */
    v2MeVerificationsPaymentMethodsGet(requestParameters, options) {
        return MePaymentVerificationsApiFp(this.configuration).v2MeVerificationsPaymentMethodsGet(requestParameters.xPlatformKey, requestParameters.localeCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Starts a payment verification session with the payment provider
     * @param {MePaymentVerificationsApiV2MeVerificationsPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MePaymentVerificationsApi
     */
    v2MeVerificationsPaymentPost(requestParameters = {}, options) {
        return MePaymentVerificationsApiFp(this.configuration).v2MeVerificationsPaymentPost(requestParameters.v2MeVerificationsPaymentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MePreferenceCategoriesApi - axios parameter creator
 * @export
 */
export const MePreferenceCategoriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change the follow setting for an individual category
         * @param {string} categoryId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesCategoryIdPut: (categoryId, v2MePreferencesCategoriesCategoryIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesCategoryIdPut', 'categoryId', categoryId);
            const localVarPath = `/v2/me/preferences/categories/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesCategoriesCategoryIdPutRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the followed categories of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {CategoryType} [type]
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesGet: (xPlatformKey, type, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MePreferencesCategoriesGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/preferences/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Follow or unfollow multiple categories
         * @param {V2MePreferencesCategoriesPatchRequest} [v2MePreferencesCategoriesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesPatch: (v2MePreferencesCategoriesPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesCategoriesPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MePreferenceCategoriesApi - functional programming interface
 * @export
 */
export const MePreferenceCategoriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MePreferenceCategoriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Change the follow setting for an individual category
         * @param {string} categoryId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesCategoryIdPut(categoryId, v2MePreferencesCategoriesCategoryIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesCategoriesCategoryIdPut(categoryId, v2MePreferencesCategoriesCategoryIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the followed categories of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {CategoryType} [type]
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesGet(xPlatformKey, type, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesCategoriesGet(xPlatformKey, type, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Follow or unfollow multiple categories
         * @param {V2MePreferencesCategoriesPatchRequest} [v2MePreferencesCategoriesPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesPatch(v2MePreferencesCategoriesPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesCategoriesPatch(v2MePreferencesCategoriesPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MePreferenceCategoriesApi - factory interface
 * @export
 */
export const MePreferenceCategoriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MePreferenceCategoriesApiFp(configuration);
    return {
        /**
         *
         * @summary Change the follow setting for an individual category
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesCategoryIdPut(requestParameters, options) {
            return localVarFp.v2MePreferencesCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the followed categories of a user
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesGet(requestParameters, options) {
            return localVarFp.v2MePreferencesCategoriesGet(requestParameters.xPlatformKey, requestParameters.type, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Follow or unfollow multiple categories
         * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MePreferencesCategoriesPatch(requestParameters = {}, options) {
            return localVarFp.v2MePreferencesCategoriesPatch(requestParameters.v2MePreferencesCategoriesPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MePreferenceCategoriesApi - object-oriented interface
 * @export
 * @class MePreferenceCategoriesApi
 * @extends {BaseAPI}
 */
export class MePreferenceCategoriesApi extends BaseAPI {
    /**
     *
     * @summary Change the follow setting for an individual category
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesCategoryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MePreferenceCategoriesApi
     */
    v2MePreferencesCategoriesCategoryIdPut(requestParameters, options) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the followed categories of a user
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MePreferenceCategoriesApi
     */
    v2MePreferencesCategoriesGet(requestParameters, options) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesGet(requestParameters.xPlatformKey, requestParameters.type, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Follow or unfollow multiple categories
     * @param {MePreferenceCategoriesApiV2MePreferencesCategoriesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MePreferenceCategoriesApi
     */
    v2MePreferencesCategoriesPatch(requestParameters = {}, options) {
        return MePreferenceCategoriesApiFp(this.configuration).v2MePreferencesCategoriesPatch(requestParameters.v2MePreferencesCategoriesPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MePreferenceEventsApi - axios parameter creator
 * @export
 */
export const MePreferenceEventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change the follow setting for an individual event
         * @param {string} eventId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsEventIdPut: (eventId, v2MePreferencesCategoriesCategoryIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('v2MePreferencesEventsEventIdPut', 'eventId', eventId);
            const localVarPath = `/v2/me/preferences/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesCategoriesCategoryIdPutRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the followed events of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsGet: (xPlatformKey, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MePreferencesEventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/me/preferences/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Follow or unfollow multiple events
         * @param {V2MePreferencesEventsPatchRequest} [v2MePreferencesEventsPatchRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsPatch: (v2MePreferencesEventsPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesEventsPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MePreferenceEventsApi - functional programming interface
 * @export
 */
export const MePreferenceEventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MePreferenceEventsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Change the follow setting for an individual event
         * @param {string} eventId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsEventIdPut(eventId, v2MePreferencesCategoriesCategoryIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesEventsEventIdPut(eventId, v2MePreferencesCategoriesCategoryIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the followed events of a user
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsGet(xPlatformKey, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesEventsGet(xPlatformKey, search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Follow or unfollow multiple events
         * @param {V2MePreferencesEventsPatchRequest} [v2MePreferencesEventsPatchRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsPatch(v2MePreferencesEventsPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesEventsPatch(v2MePreferencesEventsPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MePreferenceEventsApi - factory interface
 * @export
 */
export const MePreferenceEventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MePreferenceEventsApiFp(configuration);
    return {
        /**
         *
         * @summary Change the follow setting for an individual event
         * @param {MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsEventIdPut(requestParameters, options) {
            return localVarFp.v2MePreferencesEventsEventIdPut(requestParameters.eventId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the followed events of a user
         * @param {MePreferenceEventsApiV2MePreferencesEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsGet(requestParameters, options) {
            return localVarFp.v2MePreferencesEventsGet(requestParameters.xPlatformKey, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Follow or unfollow multiple events
         * @param {MePreferenceEventsApiV2MePreferencesEventsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesEventsPatch(requestParameters = {}, options) {
            return localVarFp.v2MePreferencesEventsPatch(requestParameters.v2MePreferencesEventsPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MePreferenceEventsApi - object-oriented interface
 * @export
 * @class MePreferenceEventsApi
 * @extends {BaseAPI}
 */
export class MePreferenceEventsApi extends BaseAPI {
    /**
     *
     * @summary Change the follow setting for an individual event
     * @param {MePreferenceEventsApiV2MePreferencesEventsEventIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceEventsApi
     */
    v2MePreferencesEventsEventIdPut(requestParameters, options) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsEventIdPut(requestParameters.eventId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the followed events of a user
     * @param {MePreferenceEventsApiV2MePreferencesEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceEventsApi
     */
    v2MePreferencesEventsGet(requestParameters, options) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsGet(requestParameters.xPlatformKey, requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Follow or unfollow multiple events
     * @param {MePreferenceEventsApiV2MePreferencesEventsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceEventsApi
     */
    v2MePreferencesEventsPatch(requestParameters = {}, options) {
        return MePreferenceEventsApiFp(this.configuration).v2MePreferencesEventsPatch(requestParameters.v2MePreferencesEventsPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MePreferenceProductsApi - axios parameter creator
 * @export
 */
export const MePreferenceProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the followed products of a user
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsGet: (search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (followed !== undefined) {
                localVarQueryParameter['followed'] = followed;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (combineWith !== undefined) {
                localVarQueryParameter['combine_with'] = combineWith;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Follow or unfollow multiple products
         * @param {V2MePreferencesProductsPatchRequest} [v2MePreferencesProductsPatchRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsPatch: (v2MePreferencesProductsPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesProductsPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Change the follow setting for an individual product
         * @param {string} productId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsProductIdPut: (productId, v2MePreferencesCategoriesCategoryIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2MePreferencesProductsProductIdPut', 'productId', productId);
            const localVarPath = `/v2/me/preferences/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MePreferencesCategoriesCategoryIdPutRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {Array<string>} [productListingIds]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsStatusGet: (productListingIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences/products/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (productListingIds) {
                localVarQueryParameter['product_listing_ids'] = productListingIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MePreferenceProductsApi - functional programming interface
 * @export
 */
export const MePreferenceProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MePreferenceProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the followed products of a user
         * @param {string} [search]
         * @param {boolean} [followed]
         * @param {number} [perPage]
         * @param {number} [page]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {'ascending' | 'descending'} [sortBy]
         * @param {string} [sort]
         * @param {'and' | 'or'} [combineWith]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsGet(search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesProductsGet(search, followed, perPage, page, pageSize, offset, sortBy, sort, combineWith, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Follow or unfollow multiple products
         * @param {V2MePreferencesProductsPatchRequest} [v2MePreferencesProductsPatchRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsPatch(v2MePreferencesProductsPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesProductsPatch(v2MePreferencesProductsPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Change the follow setting for an individual product
         * @param {string} productId
         * @param {V2MePreferencesCategoriesCategoryIdPutRequest} [v2MePreferencesCategoriesCategoryIdPutRequest]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsProductIdPut(productId, v2MePreferencesCategoriesCategoryIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesProductsProductIdPut(productId, v2MePreferencesCategoriesCategoryIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {Array<string>} [productListingIds]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsStatusGet(productListingIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MePreferencesProductsStatusGet(productListingIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MePreferenceProductsApi - factory interface
 * @export
 */
export const MePreferenceProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MePreferenceProductsApiFp(configuration);
    return {
        /**
         *
         * @summary Get the followed products of a user
         * @param {MePreferenceProductsApiV2MePreferencesProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsGet(requestParameters = {}, options) {
            return localVarFp.v2MePreferencesProductsGet(requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Follow or unfollow multiple products
         * @param {MePreferenceProductsApiV2MePreferencesProductsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsPatch(requestParameters = {}, options) {
            return localVarFp.v2MePreferencesProductsPatch(requestParameters.v2MePreferencesProductsPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Change the follow setting for an individual product
         * @param {MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsProductIdPut(requestParameters, options) {
            return localVarFp.v2MePreferencesProductsProductIdPut(requestParameters.productId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Given a list of product listing IDs, return whether the user has followed each product listing
         * @param {MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        v2MePreferencesProductsStatusGet(requestParameters = {}, options) {
            return localVarFp.v2MePreferencesProductsStatusGet(requestParameters.productListingIds, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MePreferenceProductsApi - object-oriented interface
 * @export
 * @class MePreferenceProductsApi
 * @extends {BaseAPI}
 */
export class MePreferenceProductsApi extends BaseAPI {
    /**
     *
     * @summary Get the followed products of a user
     * @param {MePreferenceProductsApiV2MePreferencesProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceProductsApi
     */
    v2MePreferencesProductsGet(requestParameters = {}, options) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsGet(requestParameters.search, requestParameters.followed, requestParameters.perPage, requestParameters.page, requestParameters.pageSize, requestParameters.offset, requestParameters.sortBy, requestParameters.sort, requestParameters.combineWith, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Follow or unfollow multiple products
     * @param {MePreferenceProductsApiV2MePreferencesProductsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceProductsApi
     */
    v2MePreferencesProductsPatch(requestParameters = {}, options) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsPatch(requestParameters.v2MePreferencesProductsPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Change the follow setting for an individual product
     * @param {MePreferenceProductsApiV2MePreferencesProductsProductIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceProductsApi
     */
    v2MePreferencesProductsProductIdPut(requestParameters, options) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsProductIdPut(requestParameters.productId, requestParameters.v2MePreferencesCategoriesCategoryIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Given a list of product listing IDs, return whether the user has followed each product listing
     * @param {MePreferenceProductsApiV2MePreferencesProductsStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferenceProductsApi
     */
    v2MePreferencesProductsStatusGet(requestParameters = {}, options) {
        return MePreferenceProductsApiFp(this.configuration).v2MePreferencesProductsStatusGet(requestParameters.productListingIds, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MePreferencesApi - axios parameter creator
 * @export
 */
export const MePreferencesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Deprecated] Get all the followed preferences of a user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFollowedPreferences: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MePreferencesApi - functional programming interface
 * @export
 */
export const MePreferencesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MePreferencesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Deprecated] Get all the followed preferences of a user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFollowedPreferences(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFollowedPreferences(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MePreferencesApi - factory interface
 * @export
 */
export const MePreferencesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MePreferencesApiFp(configuration);
    return {
        /**
         *
         * @summary [Deprecated] Get all the followed preferences of a user
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getFollowedPreferences(options) {
            return localVarFp.getFollowedPreferences(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MePreferencesApi - object-oriented interface
 * @export
 * @class MePreferencesApi
 * @extends {BaseAPI}
 */
export class MePreferencesApi extends BaseAPI {
    /**
     *
     * @summary [Deprecated] Get all the followed preferences of a user
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof MePreferencesApi
     */
    getFollowedPreferences(options) {
        return MePreferencesApiFp(this.configuration).getFollowedPreferences(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MeVerificationsApi - axios parameter creator
 * @export
 */
export const MeVerificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Verify a user\'s email address with a token
         * @param {V2MeVerificationsEmailPatchRequest} [v2MeVerificationsEmailPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPatch: (v2MeVerificationsEmailPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeVerificationsEmailPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send the logged in user a new email verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the verifications for the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify a user\'s phone number with a token
         * @param {V2MeVerificationsPhonePatchRequest} [v2MeVerificationsPhonePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePatch: (v2MeVerificationsPhonePatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2MeVerificationsPhonePatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send the logged in user a new phone verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/me/verifications/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MeVerificationsApi - functional programming interface
 * @export
 */
export const MeVerificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = MeVerificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Verify a user\'s email address with a token
         * @param {V2MeVerificationsEmailPatchRequest} [v2MeVerificationsEmailPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPatch(v2MeVerificationsEmailPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsEmailPatch(v2MeVerificationsEmailPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send the logged in user a new email verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsEmailPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the verifications for the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Verify a user\'s phone number with a token
         * @param {V2MeVerificationsPhonePatchRequest} [v2MeVerificationsPhonePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePatch(v2MeVerificationsPhonePatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsPhonePatch(v2MeVerificationsPhonePatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send the logged in user a new phone verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MeVerificationsPhonePost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MeVerificationsApi - factory interface
 * @export
 */
export const MeVerificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MeVerificationsApiFp(configuration);
    return {
        /**
         *
         * @summary Verify a user\'s email address with a token
         * @param {MeVerificationsApiV2MeVerificationsEmailPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPatch(requestParameters = {}, options) {
            return localVarFp.v2MeVerificationsEmailPatch(requestParameters.v2MeVerificationsEmailPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send the logged in user a new email verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsEmailPost(options) {
            return localVarFp.v2MeVerificationsEmailPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the verifications for the currently logged in user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsGet(options) {
            return localVarFp.v2MeVerificationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify a user\'s phone number with a token
         * @param {MeVerificationsApiV2MeVerificationsPhonePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePatch(requestParameters = {}, options) {
            return localVarFp.v2MeVerificationsPhonePatch(requestParameters.v2MeVerificationsPhonePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send the logged in user a new phone verification token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MeVerificationsPhonePost(options) {
            return localVarFp.v2MeVerificationsPhonePost(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MeVerificationsApi - object-oriented interface
 * @export
 * @class MeVerificationsApi
 * @extends {BaseAPI}
 */
export class MeVerificationsApi extends BaseAPI {
    /**
     *
     * @summary Verify a user\'s email address with a token
     * @param {MeVerificationsApiV2MeVerificationsEmailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeVerificationsApi
     */
    v2MeVerificationsEmailPatch(requestParameters = {}, options) {
        return MeVerificationsApiFp(this.configuration).v2MeVerificationsEmailPatch(requestParameters.v2MeVerificationsEmailPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send the logged in user a new email verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeVerificationsApi
     */
    v2MeVerificationsEmailPost(options) {
        return MeVerificationsApiFp(this.configuration).v2MeVerificationsEmailPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the verifications for the currently logged in user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeVerificationsApi
     */
    v2MeVerificationsGet(options) {
        return MeVerificationsApiFp(this.configuration).v2MeVerificationsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify a user\'s phone number with a token
     * @param {MeVerificationsApiV2MeVerificationsPhonePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeVerificationsApi
     */
    v2MeVerificationsPhonePatch(requestParameters = {}, options) {
        return MeVerificationsApiFp(this.configuration).v2MeVerificationsPhonePatch(requestParameters.v2MeVerificationsPhonePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send the logged in user a new phone verification token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeVerificationsApi
     */
    v2MeVerificationsPhonePost(options) {
        return MeVerificationsApiFp(this.configuration).v2MeVerificationsPhonePost(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * MenuHierarchiesApi - axios parameter creator
 * @export
 */
export const MenuHierarchiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] It will provide the tree starting from the ids.
         * @param {boolean} [includeLiveEvents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MenuHierarchiesGet: (xPlatformKey, menuHierarchyIds, includeLiveEvents, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2MenuHierarchiesGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/menu-hierarchies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (menuHierarchyIds !== undefined) {
                localVarQueryParameter['menu_hierarchy_ids'] = menuHierarchyIds;
            }
            if (includeLiveEvents !== undefined) {
                localVarQueryParameter['include_live_events'] = includeLiveEvents;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * MenuHierarchiesApi - functional programming interface
 * @export
 */
export const MenuHierarchiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = MenuHierarchiesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] It will provide the tree starting from the ids.
         * @param {boolean} [includeLiveEvents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MenuHierarchiesGet(xPlatformKey, menuHierarchyIds, includeLiveEvents, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MenuHierarchiesGet(xPlatformKey, menuHierarchyIds, includeLiveEvents, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * MenuHierarchiesApi - factory interface
 * @export
 */
export const MenuHierarchiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = MenuHierarchiesApiFp(configuration);
    return {
        /**
         *
         * @summary List all menu hierarchy trees
         * @param {MenuHierarchiesApiV2MenuHierarchiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MenuHierarchiesGet(requestParameters, options) {
            return localVarFp.v2MenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, requestParameters.includeLiveEvents, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * MenuHierarchiesApi - object-oriented interface
 * @export
 * @class MenuHierarchiesApi
 * @extends {BaseAPI}
 */
export class MenuHierarchiesApi extends BaseAPI {
    /**
     *
     * @summary List all menu hierarchy trees
     * @param {MenuHierarchiesApiV2MenuHierarchiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MenuHierarchiesApi
     */
    v2MenuHierarchiesGet(requestParameters, options) {
        return MenuHierarchiesApiFp(this.configuration).v2MenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, requestParameters.includeLiveEvents, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsGet: (pageSize, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsIdReadPatch: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('v2NotificationsIdReadPatch', 'id', id);
            const localVarPath = `/v2/notifications/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {V2NotificationsPostRequest} [v2NotificationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsPost: (v2NotificationsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2NotificationsPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsReadAllPatch: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/notifications/read/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsGet(pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2NotificationsGet(pageSize, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsIdReadPatch(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2NotificationsIdReadPatch(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {V2NotificationsPostRequest} [v2NotificationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsPost(v2NotificationsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2NotificationsPost(v2NotificationsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsReadAllPatch(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2NotificationsReadAllPatch(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationsApiFp(configuration);
    return {
        /**
         *
         * @param {NotificationsApiV2NotificationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsGet(requestParameters = {}, options) {
            return localVarFp.v2NotificationsGet(requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NotificationsApiV2NotificationsIdReadPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsIdReadPatch(requestParameters, options) {
            return localVarFp.v2NotificationsIdReadPatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {NotificationsApiV2NotificationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsPost(requestParameters = {}, options) {
            return localVarFp.v2NotificationsPost(requestParameters.v2NotificationsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2NotificationsReadAllPatch(options) {
            return localVarFp.v2NotificationsReadAllPatch(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     *
     * @param {NotificationsApiV2NotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    v2NotificationsGet(requestParameters = {}, options) {
        return NotificationsApiFp(this.configuration).v2NotificationsGet(requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NotificationsApiV2NotificationsIdReadPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    v2NotificationsIdReadPatch(requestParameters, options) {
        return NotificationsApiFp(this.configuration).v2NotificationsIdReadPatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {NotificationsApiV2NotificationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    v2NotificationsPost(requestParameters = {}, options) {
        return NotificationsApiFp(this.configuration).v2NotificationsPost(requestParameters.v2NotificationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    v2NotificationsReadAllPatch(options) {
        return NotificationsApiFp(this.configuration).v2NotificationsReadAllPatch(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderInvoiceApi - axios parameter creator
 * @export
 */
export const OrderInvoiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  This will return the invoice pdf url for the order,  the pdf url will not be accessible after 5 minutes.
         * @param {string} orderId The order to get the invoices for.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceGet: (orderId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdInvoiceGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdInvoiceGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/invoice`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrderInvoiceApi - functional programming interface
 * @export
 */
export const OrderInvoiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderInvoiceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  This will return the invoice pdf url for the order,  the pdf url will not be accessible after 5 minutes.
         * @param {string} orderId The order to get the invoices for.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceGet(orderId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdInvoiceGet(orderId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrderInvoiceApi - factory interface
 * @export
 */
export const OrderInvoiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderInvoiceApiFp(configuration);
    return {
        /**
         *
         * @summary  This will return the invoice pdf url for the order,  the pdf url will not be accessible after 5 minutes.
         * @param {OrderInvoiceApiV2OrdersOrderIdInvoiceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceGet(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdInvoiceGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderInvoiceApi - object-oriented interface
 * @export
 * @class OrderInvoiceApi
 * @extends {BaseAPI}
 */
export class OrderInvoiceApi extends BaseAPI {
    /**
     *
     * @summary  This will return the invoice pdf url for the order,  the pdf url will not be accessible after 5 minutes.
     * @param {OrderInvoiceApiV2OrdersOrderIdInvoiceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderInvoiceApi
     */
    v2OrdersOrderIdInvoiceGet(requestParameters, options) {
        return OrderInvoiceApiFp(this.configuration).v2OrdersOrderIdInvoiceGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderPaymentsApi - axios parameter creator
 * @export
 */
export const OrderPaymentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod]
         * @param {string} [shippingAddressId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentDetailsGet: (orderId, xPlatformKey, paymentMethod, shippingAddressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentDetailsGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentDetailsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/payment-details`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paymentMethod !== undefined) {
                localVarQueryParameter['payment_method'] = paymentMethod;
            }
            if (shippingAddressId !== undefined) {
                localVarQueryParameter['shipping_address_id'] = shippingAddressId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [localeCode]
         * @param {string} [billingAddressId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentMethodsGet: (orderId, xPlatformKey, localeCode, billingAddressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentMethodsGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentMethodsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/payment-methods`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (localeCode !== undefined) {
                localVarQueryParameter['locale_code'] = localeCode;
            }
            if (billingAddressId !== undefined) {
                localVarQueryParameter['billing_address_id'] = billingAddressId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdPaymentPostRequest} [v2OrdersOrderIdPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentPost: (orderId, xPlatformKey, v2OrdersOrderIdPaymentPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdPaymentPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/payment`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2OrdersOrderIdPaymentPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrderPaymentsApi - functional programming interface
 * @export
 */
export const OrderPaymentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderPaymentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod]
         * @param {string} [shippingAddressId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentDetailsGet(orderId, xPlatformKey, paymentMethod, shippingAddressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdPaymentDetailsGet(orderId, xPlatformKey, paymentMethod, shippingAddressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [localeCode]
         * @param {string} [billingAddressId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentMethodsGet(orderId, xPlatformKey, localeCode, billingAddressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdPaymentMethodsGet(orderId, xPlatformKey, localeCode, billingAddressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdPaymentPostRequest} [v2OrdersOrderIdPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentPost(orderId, xPlatformKey, v2OrdersOrderIdPaymentPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdPaymentPost(orderId, xPlatformKey, v2OrdersOrderIdPaymentPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrderPaymentsApi - factory interface
 * @export
 */
export const OrderPaymentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderPaymentsApiFp(configuration);
    return {
        /**
         *
         * @param {OrderPaymentsApiV2OrdersOrderIdPaymentDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentDetailsGet(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdPaymentDetailsGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderPaymentsApiV2OrdersOrderIdPaymentMethodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentMethodsGet(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdPaymentMethodsGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.localeCode, requestParameters.billingAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {OrderPaymentsApiV2OrdersOrderIdPaymentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPaymentPost(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdPaymentPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdPaymentPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderPaymentsApi - object-oriented interface
 * @export
 * @class OrderPaymentsApi
 * @extends {BaseAPI}
 */
export class OrderPaymentsApi extends BaseAPI {
    /**
     *
     * @param {OrderPaymentsApiV2OrdersOrderIdPaymentDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderPaymentsApi
     */
    v2OrdersOrderIdPaymentDetailsGet(requestParameters, options) {
        return OrderPaymentsApiFp(this.configuration).v2OrdersOrderIdPaymentDetailsGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderPaymentsApiV2OrdersOrderIdPaymentMethodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderPaymentsApi
     */
    v2OrdersOrderIdPaymentMethodsGet(requestParameters, options) {
        return OrderPaymentsApiFp(this.configuration).v2OrdersOrderIdPaymentMethodsGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.localeCode, requestParameters.billingAddressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {OrderPaymentsApiV2OrdersOrderIdPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderPaymentsApi
     */
    v2OrdersOrderIdPaymentPost(requestParameters, options) {
        return OrderPaymentsApiFp(this.configuration).v2OrdersOrderIdPaymentPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdPaymentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrderTransactionsApi - axios parameter creator
 * @export
 */
export const OrderTransactionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdTransactionsPostRequest} [v2OrdersOrderIdTransactionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdTransactionsPost: (orderId, xPlatformKey, v2OrdersOrderIdTransactionsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdTransactionsPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdTransactionsPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/transactions`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2OrdersOrderIdTransactionsPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrderTransactionsApi - functional programming interface
 * @export
 */
export const OrderTransactionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrderTransactionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdTransactionsPostRequest} [v2OrdersOrderIdTransactionsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdTransactionsPost(orderId, xPlatformKey, v2OrdersOrderIdTransactionsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdTransactionsPost(orderId, xPlatformKey, v2OrdersOrderIdTransactionsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrderTransactionsApi - factory interface
 * @export
 */
export const OrderTransactionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrderTransactionsApiFp(configuration);
    return {
        /**
         *
         * @param {OrderTransactionsApiV2OrdersOrderIdTransactionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdTransactionsPost(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdTransactionsPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdTransactionsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrderTransactionsApi - object-oriented interface
 * @export
 * @class OrderTransactionsApi
 * @extends {BaseAPI}
 */
export class OrderTransactionsApi extends BaseAPI {
    /**
     *
     * @param {OrderTransactionsApiV2OrdersOrderIdTransactionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTransactionsApi
     */
    v2OrdersOrderIdTransactionsPost(requestParameters, options) {
        return OrderTransactionsApiFp(this.configuration).v2OrdersOrderIdTransactionsPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdTransactionsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdCanBeFramedGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdCanBeFramedGet', 'orderId', orderId);
            const localVarPath = `/v2/orders/{orderId}/can-be-framed`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Checks if a frame configuration session already exists for the specified order. If so, it returns the  session id of the existing framing session. If not, a new framing session is created and its session  id returned. A shipping country code is also returned because this needs to be passed as a query string  parameter into the configurator URL.
         * @summary Create or get the framing session associated with the order
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [framePreviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdFramingSessionPost: (orderId, xPlatformKey, framePreviewId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdFramingSessionPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdFramingSessionPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/framing-session`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (framePreviewId !== undefined) {
                localVarQueryParameter['frame_preview_id'] = framePreviewId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch a single order by id
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdGet: (orderId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * When this endpoint is called, a temporary URL is created that contains the PDF file with  invoice details for the specified order. The file is available for 5 minutes before it  expires.
         * @summary Generate a temporary url that hosts the invoice PDF file for 5 minutes.
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceUrlPost: (orderId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdInvoiceUrlPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdInvoiceUrlPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}/invoice-url`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Sets a payment back to open if it is processing
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdOpenPatch: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdOpenPatch', 'orderId', orderId);
            const localVarPath = `/v2/orders/{orderId}/open`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is the endpoint through which end-users can update certain properties of orders
         * @summary Update an order
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdPatchRequest} [v2OrdersOrderIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPatch: (orderId, xPlatformKey, v2OrdersOrderIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('v2OrdersOrderIdPatch', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2OrdersOrderIdPatch', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2OrdersOrderIdPatchRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdCanBeFramedGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdCanBeFramedGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Checks if a frame configuration session already exists for the specified order. If so, it returns the  session id of the existing framing session. If not, a new framing session is created and its session  id returned. A shipping country code is also returned because this needs to be passed as a query string  parameter into the configurator URL.
         * @summary Create or get the framing session associated with the order
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [framePreviewId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdFramingSessionPost(orderId, xPlatformKey, framePreviewId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdFramingSessionPost(orderId, xPlatformKey, framePreviewId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Fetch a single order by id
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdGet(orderId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdGet(orderId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * When this endpoint is called, a temporary URL is created that contains the PDF file with  invoice details for the specified order. The file is available for 5 minutes before it  expires.
         * @summary Generate a temporary url that hosts the invoice PDF file for 5 minutes.
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceUrlPost(orderId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdInvoiceUrlPost(orderId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Sets a payment back to open if it is processing
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdOpenPatch(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdOpenPatch(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This is the endpoint through which end-users can update certain properties of orders
         * @summary Update an order
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2OrdersOrderIdPatchRequest} [v2OrdersOrderIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPatch(orderId, xPlatformKey, v2OrdersOrderIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2OrdersOrderIdPatch(orderId, xPlatformKey, v2OrdersOrderIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {OrdersApiV2OrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdCanBeFramedGet(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if a frame configuration session already exists for the specified order. If so, it returns the  session id of the existing framing session. If not, a new framing session is created and its session  id returned. A shipping country code is also returned because this needs to be passed as a query string  parameter into the configurator URL.
         * @summary Create or get the framing session associated with the order
         * @param {OrdersApiV2OrdersOrderIdFramingSessionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdFramingSessionPost(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdFramingSessionPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.framePreviewId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch a single order by id
         * @param {OrdersApiV2OrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdGet(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * When this endpoint is called, a temporary URL is created that contains the PDF file with  invoice details for the specified order. The file is available for 5 minutes before it  expires.
         * @summary Generate a temporary url that hosts the invoice PDF file for 5 minutes.
         * @param {OrdersApiV2OrdersOrderIdInvoiceUrlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdInvoiceUrlPost(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdInvoiceUrlPost(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Sets a payment back to open if it is processing
         * @param {OrdersApiV2OrdersOrderIdOpenPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdOpenPatch(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdOpenPatch(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the endpoint through which end-users can update certain properties of orders
         * @summary Update an order
         * @param {OrdersApiV2OrdersOrderIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2OrdersOrderIdPatch(requestParameters, options) {
            return localVarFp.v2OrdersOrderIdPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     *
     * @summary [User] Returns a boolean indicating whether framing for an order can be started
     * @param {OrdersApiV2OrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdCanBeFramedGet(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Checks if a frame configuration session already exists for the specified order. If so, it returns the  session id of the existing framing session. If not, a new framing session is created and its session  id returned. A shipping country code is also returned because this needs to be passed as a query string  parameter into the configurator URL.
     * @summary Create or get the framing session associated with the order
     * @param {OrdersApiV2OrdersOrderIdFramingSessionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdFramingSessionPost(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdFramingSessionPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.framePreviewId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch a single order by id
     * @param {OrdersApiV2OrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdGet(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * When this endpoint is called, a temporary URL is created that contains the PDF file with  invoice details for the specified order. The file is available for 5 minutes before it  expires.
     * @summary Generate a temporary url that hosts the invoice PDF file for 5 minutes.
     * @param {OrdersApiV2OrdersOrderIdInvoiceUrlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdInvoiceUrlPost(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdInvoiceUrlPost(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Sets a payment back to open if it is processing
     * @param {OrdersApiV2OrdersOrderIdOpenPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdOpenPatch(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdOpenPatch(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the endpoint through which end-users can update certain properties of orders
     * @summary Update an order
     * @param {OrdersApiV2OrdersOrderIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    v2OrdersOrderIdPatch(requestParameters, options) {
        return OrdersApiFp(this.configuration).v2OrdersOrderIdPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.v2OrdersOrderIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PaymentTokensApi - axios parameter creator
 * @export
 */
export const PaymentTokensApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all payment tokens for the user.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensGet: (offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the payment methods for tokenization
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentMethodsGet: (localeCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/tokens/payment/methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (localeCode !== undefined) {
                localVarQueryParameter['locale_code'] = localeCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Start tokenization payment
         * @param {V2TokensPaymentPostRequest} [v2TokensPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentPost: (v2TokensPaymentPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/tokens/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2TokensPaymentPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a payment session for tokenization
         * @param {V2TokensPaymentSessionPostRequest} [v2TokensPaymentSessionPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentSessionPost: (v2TokensPaymentSessionPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/tokens/payment/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2TokensPaymentSessionPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a payment token.
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdDelete: (paymentTokenId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentTokenId' is not null or undefined
            assertParamExists('v2TokensPaymentTokenIdDelete', 'paymentTokenId', paymentTokenId);
            const localVarPath = `/v2/tokens/{paymentTokenId}`
                .replace(`{${"paymentTokenId"}}`, encodeURIComponent(String(paymentTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sets a specific payment token as the default for the user.
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdSetDefaultPut: (paymentTokenId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'paymentTokenId' is not null or undefined
            assertParamExists('v2TokensPaymentTokenIdSetDefaultPut', 'paymentTokenId', paymentTokenId);
            const localVarPath = `/v2/tokens/{paymentTokenId}/set-default`
                .replace(`{${"paymentTokenId"}}`, encodeURIComponent(String(paymentTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentTokensApi - functional programming interface
 * @export
 */
export const PaymentTokensApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentTokensApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all payment tokens for the user.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensGet(offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensGet(offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the payment methods for tokenization
         * @param {string} [localeCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentMethodsGet(localeCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensPaymentMethodsGet(localeCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Start tokenization payment
         * @param {V2TokensPaymentPostRequest} [v2TokensPaymentPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentPost(v2TokensPaymentPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensPaymentPost(v2TokensPaymentPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a payment session for tokenization
         * @param {V2TokensPaymentSessionPostRequest} [v2TokensPaymentSessionPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentSessionPost(v2TokensPaymentSessionPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensPaymentSessionPost(v2TokensPaymentSessionPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a payment token.
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdDelete(paymentTokenId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensPaymentTokenIdDelete(paymentTokenId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sets a specific payment token as the default for the user.
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdSetDefaultPut(paymentTokenId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TokensPaymentTokenIdSetDefaultPut(paymentTokenId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentTokensApi - factory interface
 * @export
 */
export const PaymentTokensApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentTokensApiFp(configuration);
    return {
        /**
         *
         * @summary Get all payment tokens for the user.
         * @param {PaymentTokensApiV2TokensGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensGet(requestParameters = {}, options) {
            return localVarFp.v2TokensGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the payment methods for tokenization
         * @param {PaymentTokensApiV2TokensPaymentMethodsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentMethodsGet(requestParameters = {}, options) {
            return localVarFp.v2TokensPaymentMethodsGet(requestParameters.localeCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start tokenization payment
         * @param {PaymentTokensApiV2TokensPaymentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentPost(requestParameters = {}, options) {
            return localVarFp.v2TokensPaymentPost(requestParameters.v2TokensPaymentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a payment session for tokenization
         * @param {PaymentTokensApiV2TokensPaymentSessionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentSessionPost(requestParameters = {}, options) {
            return localVarFp.v2TokensPaymentSessionPost(requestParameters.v2TokensPaymentSessionPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a payment token.
         * @param {PaymentTokensApiV2TokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdDelete(requestParameters, options) {
            return localVarFp.v2TokensPaymentTokenIdDelete(requestParameters.paymentTokenId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets a specific payment token as the default for the user.
         * @param {PaymentTokensApiV2TokensPaymentTokenIdSetDefaultPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TokensPaymentTokenIdSetDefaultPut(requestParameters, options) {
            return localVarFp.v2TokensPaymentTokenIdSetDefaultPut(requestParameters.paymentTokenId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentTokensApi - object-oriented interface
 * @export
 * @class PaymentTokensApi
 * @extends {BaseAPI}
 */
export class PaymentTokensApi extends BaseAPI {
    /**
     *
     * @summary Get all payment tokens for the user.
     * @param {PaymentTokensApiV2TokensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensGet(requestParameters = {}, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensGet(requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the payment methods for tokenization
     * @param {PaymentTokensApiV2TokensPaymentMethodsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensPaymentMethodsGet(requestParameters = {}, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensPaymentMethodsGet(requestParameters.localeCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start tokenization payment
     * @param {PaymentTokensApiV2TokensPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensPaymentPost(requestParameters = {}, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensPaymentPost(requestParameters.v2TokensPaymentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a payment session for tokenization
     * @param {PaymentTokensApiV2TokensPaymentSessionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensPaymentSessionPost(requestParameters = {}, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensPaymentSessionPost(requestParameters.v2TokensPaymentSessionPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a payment token.
     * @param {PaymentTokensApiV2TokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensPaymentTokenIdDelete(requestParameters, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensPaymentTokenIdDelete(requestParameters.paymentTokenId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets a specific payment token as the default for the user.
     * @param {PaymentTokensApiV2TokensPaymentTokenIdSetDefaultPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentTokensApi
     */
    v2TokensPaymentTokenIdSetDefaultPut(requestParameters, options) {
        return PaymentTokensApiFp(this.configuration).v2TokensPaymentTokenIdSetDefaultPut(requestParameters.paymentTokenId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PlatformAppVersionsApi - axios parameter creator
 * @export
 */
export const PlatformAppVersionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get if an app version is still supported or should be forced to be updated
         * @param {string} platformId
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlatformsPlatformIdAppVersionsGet: (platformId, version, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('v2PlatformsPlatformIdAppVersionsGet', 'platformId', platformId);
            const localVarPath = `/v2/platforms/{platformId}/app-versions`
                .replace(`{${"platformId"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PlatformAppVersionsApi - functional programming interface
 * @export
 */
export const PlatformAppVersionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PlatformAppVersionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get if an app version is still supported or should be forced to be updated
         * @param {string} platformId
         * @param {string} [version]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlatformsPlatformIdAppVersionsGet(platformId, version, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2PlatformsPlatformIdAppVersionsGet(platformId, version, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PlatformAppVersionsApi - factory interface
 * @export
 */
export const PlatformAppVersionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PlatformAppVersionsApiFp(configuration);
    return {
        /**
         *
         * @summary get if an app version is still supported or should be forced to be updated
         * @param {PlatformAppVersionsApiV2PlatformsPlatformIdAppVersionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2PlatformsPlatformIdAppVersionsGet(requestParameters, options) {
            return localVarFp.v2PlatformsPlatformIdAppVersionsGet(requestParameters.platformId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PlatformAppVersionsApi - object-oriented interface
 * @export
 * @class PlatformAppVersionsApi
 * @extends {BaseAPI}
 */
export class PlatformAppVersionsApi extends BaseAPI {
    /**
     *
     * @summary get if an app version is still supported or should be forced to be updated
     * @param {PlatformAppVersionsApiV2PlatformsPlatformIdAppVersionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformAppVersionsApi
     */
    v2PlatformsPlatformIdAppVersionsGet(requestParameters, options) {
        return PlatformAppVersionsApiFp(this.configuration).v2PlatformsPlatformIdAppVersionsGet(requestParameters.platformId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductBidsApi - axios parameter creator
 * @export
 */
export const ProductBidsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get bids placed on a product.
         * @param {string} productId Uniquely identify product by Id
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsGet: (productId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsGet', 'productId', productId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/{productId}/bids`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Place a bid on a product.
         * @param {string} productId Uniquely identify the product to bid on by Guid
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductsProductIdBidsPostRequest} [v2ProductsProductIdBidsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsPost: (productId, xPlatformKey, v2ProductsProductIdBidsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsPost', 'productId', productId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdBidsPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/{productId}/bids`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2ProductsProductIdBidsPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductBidsApi - functional programming interface
 * @export
 */
export const ProductBidsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductBidsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get bids placed on a product.
         * @param {string} productId Uniquely identify product by Id
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsGet(productId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsProductIdBidsGet(productId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Place a bid on a product.
         * @param {string} productId Uniquely identify the product to bid on by Guid
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductsProductIdBidsPostRequest} [v2ProductsProductIdBidsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsPost(productId, xPlatformKey, v2ProductsProductIdBidsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsProductIdBidsPost(productId, xPlatformKey, v2ProductsProductIdBidsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductBidsApi - factory interface
 * @export
 */
export const ProductBidsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductBidsApiFp(configuration);
    return {
        /**
         *
         * @summary Get bids placed on a product.
         * @param {ProductBidsApiV2ProductsProductIdBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsGet(requestParameters, options) {
            return localVarFp.v2ProductsProductIdBidsGet(requestParameters.productId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Place a bid on a product.
         * @param {ProductBidsApiV2ProductsProductIdBidsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdBidsPost(requestParameters, options) {
            return localVarFp.v2ProductsProductIdBidsPost(requestParameters.productId, requestParameters.xPlatformKey, requestParameters.v2ProductsProductIdBidsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductBidsApi - object-oriented interface
 * @export
 * @class ProductBidsApi
 * @extends {BaseAPI}
 */
export class ProductBidsApi extends BaseAPI {
    /**
     *
     * @summary Get bids placed on a product.
     * @param {ProductBidsApiV2ProductsProductIdBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductBidsApi
     */
    v2ProductsProductIdBidsGet(requestParameters, options) {
        return ProductBidsApiFp(this.configuration).v2ProductsProductIdBidsGet(requestParameters.productId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Place a bid on a product.
     * @param {ProductBidsApiV2ProductsProductIdBidsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductBidsApi
     */
    v2ProductsProductIdBidsPost(requestParameters, options) {
        return ProductBidsApiFp(this.configuration).v2ProductsProductIdBidsPost(requestParameters.productId, requestParameters.xPlatformKey, requestParameters.v2ProductsProductIdBidsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductFramingApi - axios parameter creator
 * @export
 */
export const ProductFramingApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Start a new framing session
         * @param {string} productId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductsProductIdFramingPostRequest} [v2ProductsProductIdFramingPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdFramingPost: (productId, xPlatformKey, v2ProductsProductIdFramingPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('v2ProductsProductIdFramingPost', 'productId', productId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdFramingPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/{productId}/framing`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2ProductsProductIdFramingPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductFramingApi - functional programming interface
 * @export
 */
export const ProductFramingApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductFramingApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Start a new framing session
         * @param {string} productId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductsProductIdFramingPostRequest} [v2ProductsProductIdFramingPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdFramingPost(productId, xPlatformKey, v2ProductsProductIdFramingPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsProductIdFramingPost(productId, xPlatformKey, v2ProductsProductIdFramingPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductFramingApi - factory interface
 * @export
 */
export const ProductFramingApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductFramingApiFp(configuration);
    return {
        /**
         *
         * @summary Start a new framing session
         * @param {ProductFramingApiV2ProductsProductIdFramingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdFramingPost(requestParameters, options) {
            return localVarFp.v2ProductsProductIdFramingPost(requestParameters.productId, requestParameters.xPlatformKey, requestParameters.v2ProductsProductIdFramingPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductFramingApi - object-oriented interface
 * @export
 * @class ProductFramingApi
 * @extends {BaseAPI}
 */
export class ProductFramingApi extends BaseAPI {
    /**
     *
     * @summary Start a new framing session
     * @param {ProductFramingApiV2ProductsProductIdFramingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFramingApi
     */
    v2ProductsProductIdFramingPost(requestParameters, options) {
        return ProductFramingApiFp(this.configuration).v2ProductsProductIdFramingPost(requestParameters.productId, requestParameters.xPlatformKey, requestParameters.v2ProductsProductIdFramingPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductListingFavouritesApi - axios parameter creator
 * @export
 */
export const ProductListingFavouritesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {'closing_time' | 'price'} [sortField]
         * @param {'ascending' | 'descending'} [direction]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [categoryIds]
         * @param {BiddingStatus} [biddingStatus]
         * @param {boolean} [endsInHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsFavouritesGet: (sortField, direction, offset, pageSize, categoryIds, biddingStatus, endsInHour, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/product-listings/favourites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (sortField !== undefined) {
                localVarQueryParameter['sort_field'] = sortField;
            }
            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }
            if (biddingStatus !== undefined) {
                localVarQueryParameter['bidding_status'] = biddingStatus;
            }
            if (endsInHour !== undefined) {
                localVarQueryParameter['ends_in_hour'] = endsInHour;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductListingFavouritesApi - functional programming interface
 * @export
 */
export const ProductListingFavouritesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductListingFavouritesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {'closing_time' | 'price'} [sortField]
         * @param {'ascending' | 'descending'} [direction]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {string} [categoryIds]
         * @param {BiddingStatus} [biddingStatus]
         * @param {boolean} [endsInHour]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsFavouritesGet(sortField, direction, offset, pageSize, categoryIds, biddingStatus, endsInHour, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductListingsFavouritesGet(sortField, direction, offset, pageSize, categoryIds, biddingStatus, endsInHour, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductListingFavouritesApi - factory interface
 * @export
 */
export const ProductListingFavouritesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductListingFavouritesApiFp(configuration);
    return {
        /**
         *
         * @param {ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsFavouritesGet(requestParameters = {}, options) {
            return localVarFp.v2ProductListingsFavouritesGet(requestParameters.sortField, requestParameters.direction, requestParameters.offset, requestParameters.pageSize, requestParameters.categoryIds, requestParameters.biddingStatus, requestParameters.endsInHour, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductListingFavouritesApi - object-oriented interface
 * @export
 * @class ProductListingFavouritesApi
 * @extends {BaseAPI}
 */
export class ProductListingFavouritesApi extends BaseAPI {
    /**
     *
     * @param {ProductListingFavouritesApiV2ProductListingsFavouritesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListingFavouritesApi
     */
    v2ProductListingsFavouritesGet(requestParameters = {}, options) {
        return ProductListingFavouritesApiFp(this.configuration).v2ProductListingsFavouritesGet(requestParameters.sortField, requestParameters.direction, requestParameters.offset, requestParameters.pageSize, requestParameters.categoryIds, requestParameters.biddingStatus, requestParameters.endsInHour, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductListingsBidsApi - axios parameter creator
 * @export
 */
export const ProductListingsBidsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get an active max bid by product listing and user id.
         * @param {string} productListingId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxGet: (productListingId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productListingId' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxGet', 'productListingId', productListingId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/product-listings/{productListingId}/bids/max`
                .replace(`{${"productListingId"}}`, encodeURIComponent(String(productListingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Place a max bid on a product.
         * @param {string} productListingId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductListingsProductListingIdBidsMaxPostRequest} [v2ProductListingsProductListingIdBidsMaxPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxPost: (productListingId, xPlatformKey, v2ProductListingsProductListingIdBidsMaxPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productListingId' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxPost', 'productListingId', productListingId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductListingsProductListingIdBidsMaxPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/product-listings/{productListingId}/bids/max`
                .replace(`{${"productListingId"}}`, encodeURIComponent(String(productListingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2ProductListingsProductListingIdBidsMaxPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductListingsBidsApi - functional programming interface
 * @export
 */
export const ProductListingsBidsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductListingsBidsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get an active max bid by product listing and user id.
         * @param {string} productListingId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxGet(productListingId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductListingsProductListingIdBidsMaxGet(productListingId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Place a max bid on a product.
         * @param {string} productListingId
         * @param {string} xPlatformKey Select the platform.
         * @param {V2ProductListingsProductListingIdBidsMaxPostRequest} [v2ProductListingsProductListingIdBidsMaxPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxPost(productListingId, xPlatformKey, v2ProductListingsProductListingIdBidsMaxPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductListingsProductListingIdBidsMaxPost(productListingId, xPlatformKey, v2ProductListingsProductListingIdBidsMaxPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductListingsBidsApi - factory interface
 * @export
 */
export const ProductListingsBidsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductListingsBidsApiFp(configuration);
    return {
        /**
         *
         * @summary Get an active max bid by product listing and user id.
         * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxGet(requestParameters, options) {
            return localVarFp.v2ProductListingsProductListingIdBidsMaxGet(requestParameters.productListingId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Place a max bid on a product.
         * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductListingsProductListingIdBidsMaxPost(requestParameters, options) {
            return localVarFp.v2ProductListingsProductListingIdBidsMaxPost(requestParameters.productListingId, requestParameters.xPlatformKey, requestParameters.v2ProductListingsProductListingIdBidsMaxPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductListingsBidsApi - object-oriented interface
 * @export
 * @class ProductListingsBidsApi
 * @extends {BaseAPI}
 */
export class ProductListingsBidsApi extends BaseAPI {
    /**
     *
     * @summary Get an active max bid by product listing and user id.
     * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListingsBidsApi
     */
    v2ProductListingsProductListingIdBidsMaxGet(requestParameters, options) {
        return ProductListingsBidsApiFp(this.configuration).v2ProductListingsProductListingIdBidsMaxGet(requestParameters.productListingId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Place a max bid on a product.
     * @param {ProductListingsBidsApiV2ProductListingsProductListingIdBidsMaxPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductListingsBidsApi
     */
    v2ProductListingsProductListingIdBidsMaxPost(requestParameters, options) {
        return ProductListingsBidsApiFp(this.configuration).v2ProductListingsProductListingIdBidsMaxPost(requestParameters.productListingId, requestParameters.xPlatformKey, requestParameters.v2ProductListingsProductListingIdBidsMaxPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get product by certificate number
         * @param {string} certificateNumber
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsCertificateCertificateNumberGet: (certificateNumber, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'certificateNumber' is not null or undefined
            assertParamExists('v2ProductsCertificateCertificateNumberGet', 'certificateNumber', certificateNumber);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsCertificateCertificateNumberGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/certificate/{certificateNumber}`
                .replace(`{${"certificateNumber"}}`, encodeURIComponent(String(certificateNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.  This endpoint will be deprecated at 2024-02-04
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy]
         * @param {number} [minimumPrice]
         * @param {number} [maximumPrice]
         * @param {string} [currencyCode]
         * @param {ProductStatus} [productStatus]
         * @param {string} [categoryIds]
         * @param {string} [productIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsGet: (xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }
            if (categorySlug !== undefined) {
                localVarQueryParameter['category_slug'] = categorySlug;
            }
            if (salesMethod !== undefined) {
                localVarQueryParameter['sales_method'] = salesMethod;
            }
            if (onlyReturnNotEnded !== undefined) {
                localVarQueryParameter['only_return_not_ended'] = onlyReturnNotEnded;
            }
            if (returnNotStarted !== undefined) {
                localVarQueryParameter['return_not_started'] = returnNotStarted;
            }
            if (sortByCreateDate !== undefined) {
                localVarQueryParameter['sort_by_create_date'] = sortByCreateDate;
            }
            if (sortProductsBy !== undefined) {
                localVarQueryParameter['sort_products_by'] = sortProductsBy;
            }
            if (minimumPrice !== undefined) {
                localVarQueryParameter['minimum_price'] = minimumPrice;
            }
            if (maximumPrice !== undefined) {
                localVarQueryParameter['maximum_price'] = maximumPrice;
            }
            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }
            if (productStatus !== undefined) {
                localVarQueryParameter['product_status'] = productStatus;
            }
            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }
            if (productIds !== undefined) {
                localVarQueryParameter['product_ids'] = productIds;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get match scored ball products for a category
         * @param {string} categoryId
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numberOfProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsMatchScoredBallsCategoryCategoryIdGet: (categoryId, xPlatformKey, numberOfProducts, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('v2ProductsMatchScoredBallsCategoryCategoryIdGet', 'categoryId', categoryId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsMatchScoredBallsCategoryCategoryIdGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/match-scored-balls/category/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (numberOfProducts !== undefined) {
                localVarQueryParameter['number_of_products'] = numberOfProducts;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by sales category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy]
         * @param {number} [minimumPrice]
         * @param {number} [maximumPrice]
         * @param {string} [currencyCode]
         * @param {ProductStatus} [productStatus]
         * @param {string} [categoryIds]
         * @param {string} [productIds]
         * @param {number} [offset] The amount of items to skip in the results
         * @param {number} [pageSize] Size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsPaginatedGet: (xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsPaginatedGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (eventId !== undefined) {
                localVarQueryParameter['event_id'] = eventId;
            }
            if (categorySlug !== undefined) {
                localVarQueryParameter['category_slug'] = categorySlug;
            }
            if (salesMethod !== undefined) {
                localVarQueryParameter['sales_method'] = salesMethod;
            }
            if (onlyReturnNotEnded !== undefined) {
                localVarQueryParameter['only_return_not_ended'] = onlyReturnNotEnded;
            }
            if (returnNotStarted !== undefined) {
                localVarQueryParameter['return_not_started'] = returnNotStarted;
            }
            if (sortByCreateDate !== undefined) {
                localVarQueryParameter['sort_by_create_date'] = sortByCreateDate;
            }
            if (sortProductsBy !== undefined) {
                localVarQueryParameter['sort_products_by'] = sortProductsBy;
            }
            if (minimumPrice !== undefined) {
                localVarQueryParameter['minimum_price'] = minimumPrice;
            }
            if (maximumPrice !== undefined) {
                localVarQueryParameter['maximum_price'] = maximumPrice;
            }
            if (currencyCode !== undefined) {
                localVarQueryParameter['currency_code'] = currencyCode;
            }
            if (productStatus !== undefined) {
                localVarQueryParameter['product_status'] = productStatus;
            }
            if (categoryIds !== undefined) {
                localVarQueryParameter['category_ids'] = categoryIds;
            }
            if (productIds !== undefined) {
                localVarQueryParameter['product_ids'] = productIds;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} productIdentifier
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [currency]
         * @param {string} [countryCode]
         * @param {string} [stateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierCostEstimateGet: (productIdentifier, xPlatformKey, currency, countryCode, stateCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productIdentifier' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierCostEstimateGet', 'productIdentifier', productIdentifier);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierCostEstimateGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/{productIdentifier}/cost-estimate`
                .replace(`{${"productIdentifier"}}`, encodeURIComponent(String(productIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }
            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }
            if (stateCode !== undefined) {
                localVarQueryParameter['state_code'] = stateCode;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get product details.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierGet: (productIdentifier, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'productIdentifier' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierGet', 'productIdentifier', productIdentifier);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ProductsProductIdentifierGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/products/{productIdentifier}`
                .replace(`{${"productIdentifier"}}`, encodeURIComponent(String(productIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get product by certificate number
         * @param {string} certificateNumber
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsCertificateCertificateNumberGet(certificateNumber, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsCertificateCertificateNumberGet(certificateNumber, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.  This endpoint will be deprecated at 2024-02-04
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy]
         * @param {number} [minimumPrice]
         * @param {number} [maximumPrice]
         * @param {string} [currencyCode]
         * @param {ProductStatus} [productStatus]
         * @param {string} [categoryIds]
         * @param {string} [productIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get match scored ball products for a category
         * @param {string} categoryId
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [numberOfProducts]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsMatchScoredBallsCategoryCategoryIdGet(categoryId, xPlatformKey, numberOfProducts, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsMatchScoredBallsCategoryCategoryIdGet(categoryId, xPlatformKey, numberOfProducts, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId] Uniquely identify the event by Guid or Slug
         * @param {string} [categorySlug] Filter the products by sales category
         * @param {SalesMethod} [salesMethod] Filter the products by sales method
         * @param {boolean} [onlyReturnNotEnded] show only products that end date\&#39;s not past
         * @param {boolean} [returnNotStarted] Also return products that have not started yet
         * @param {boolean} [sortByCreateDate] After priority score, should we sort it by date of creation
         * @param {ProductSorting} [sortProductsBy]
         * @param {number} [minimumPrice]
         * @param {number} [maximumPrice]
         * @param {string} [currencyCode]
         * @param {ProductStatus} [productStatus]
         * @param {string} [categoryIds]
         * @param {string} [productIds]
         * @param {number} [offset] The amount of items to skip in the results
         * @param {number} [pageSize] Size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsPaginatedGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsPaginatedGet(xPlatformKey, eventId, categorySlug, salesMethod, onlyReturnNotEnded, returnNotStarted, sortByCreateDate, sortProductsBy, minimumPrice, maximumPrice, currencyCode, productStatus, categoryIds, productIds, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} productIdentifier
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [currency]
         * @param {string} [countryCode]
         * @param {string} [stateCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierCostEstimateGet(productIdentifier, xPlatformKey, currency, countryCode, stateCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsProductIdentifierCostEstimateGet(productIdentifier, xPlatformKey, currency, countryCode, stateCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get product details.
         * @param {string} productIdentifier Uniquely identify the product by Guid or Slug
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierGet(productIdentifier, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ProductsProductIdentifierGet(productIdentifier, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductsApiFp(configuration);
    return {
        /**
         *
         * @summary Get product by certificate number
         * @param {ProductsApiV2ProductsCertificateCertificateNumberGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsCertificateCertificateNumberGet(requestParameters, options) {
            return localVarFp.v2ProductsCertificateCertificateNumberGet(requestParameters.certificateNumber, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.  This endpoint will be deprecated at 2024-02-04
         * @param {ProductsApiV2ProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsGet(requestParameters, options) {
            return localVarFp.v2ProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get match scored ball products for a category
         * @param {ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters, options) {
            return localVarFp.v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters.categoryId, requestParameters.xPlatformKey, requestParameters.numberOfProducts, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
         * @param {ProductsApiV2ProductsPaginatedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsPaginatedGet(requestParameters, options) {
            return localVarFp.v2ProductsPaginatedGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierCostEstimateGet(requestParameters, options) {
            return localVarFp.v2ProductsProductIdentifierCostEstimateGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.currency, requestParameters.countryCode, requestParameters.stateCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get product details.
         * @param {ProductsApiV2ProductsProductIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ProductsProductIdentifierGet(requestParameters, options) {
            return localVarFp.v2ProductsProductIdentifierGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     *
     * @summary Get product by certificate number
     * @param {ProductsApiV2ProductsCertificateCertificateNumberGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsCertificateCertificateNumberGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsCertificateCertificateNumberGet(requestParameters.certificateNumber, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get products for a given published event. If no Id is provided then returns products for all published events.  This endpoint will be deprecated at 2024-02-04
     * @param {ProductsApiV2ProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get match scored ball products for a category
     * @param {ProductsApiV2ProductsMatchScoredBallsCategoryCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsMatchScoredBallsCategoryCategoryIdGet(requestParameters.categoryId, requestParameters.xPlatformKey, requestParameters.numberOfProducts, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get products for a given published event. If no Id is provided then returns products for all published events.
     * @param {ProductsApiV2ProductsPaginatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsPaginatedGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsPaginatedGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.categorySlug, requestParameters.salesMethod, requestParameters.onlyReturnNotEnded, requestParameters.returnNotStarted, requestParameters.sortByCreateDate, requestParameters.sortProductsBy, requestParameters.minimumPrice, requestParameters.maximumPrice, requestParameters.currencyCode, requestParameters.productStatus, requestParameters.categoryIds, requestParameters.productIds, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ProductsApiV2ProductsProductIdentifierCostEstimateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsProductIdentifierCostEstimateGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsProductIdentifierCostEstimateGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, requestParameters.currency, requestParameters.countryCode, requestParameters.stateCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get product details.
     * @param {ProductsApiV2ProductsProductIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    v2ProductsProductIdentifierGet(requestParameters, options) {
        return ProductsApiFp(this.configuration).v2ProductsProductIdentifierGet(requestParameters.productIdentifier, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary New endpoint for searching products, events and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [numberOfProducts]
         * @param {number} [numberOfEvents]
         * @param {number} [numberOfTeamCategories]
         * @param {number} [numberOfLeagueCategories]
         * @param {number} [numberOfOtherCategories]
         * @param {number} [numberOfCampaignCategories]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchAllGet: (xPlatformKey, searchTerm, numberOfProducts, numberOfEvents, numberOfTeamCategories, numberOfLeagueCategories, numberOfOtherCategories, numberOfCampaignCategories, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchAllGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (numberOfProducts !== undefined) {
                localVarQueryParameter['number_of_products'] = numberOfProducts;
            }
            if (numberOfEvents !== undefined) {
                localVarQueryParameter['number_of_events'] = numberOfEvents;
            }
            if (numberOfTeamCategories !== undefined) {
                localVarQueryParameter['number_of_team_categories'] = numberOfTeamCategories;
            }
            if (numberOfLeagueCategories !== undefined) {
                localVarQueryParameter['number_of_league_categories'] = numberOfLeagueCategories;
            }
            if (numberOfOtherCategories !== undefined) {
                localVarQueryParameter['number_of_other_categories'] = numberOfOtherCategories;
            }
            if (numberOfCampaignCategories !== undefined) {
                localVarQueryParameter['number_of_campaign_categories'] = numberOfCampaignCategories;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary New endpoint for searching categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {'teams' | 'leagues' | 'other' | 'campaigns'} [categorySearchType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchCategoriesGet: (xPlatformKey, searchTerm, offset, pageSize, categorySearchType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchCategoriesGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (categorySearchType !== undefined) {
                localVarQueryParameter['category_search_type'] = categorySearchType;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary New endpoint for searching events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {EventStatus} [eventFiltersEventStatus]
         * @param {string} [eventFiltersCategoryIds]
         * @param {EventSorting} [eventSorting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchEventsGet: (xPlatformKey, searchTerm, offset, pageSize, eventFiltersEventStatus, eventFiltersCategoryIds, eventSorting, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchEventsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (eventFiltersEventStatus !== undefined) {
                localVarQueryParameter['event_filters.event_status'] = eventFiltersEventStatus;
            }
            if (eventFiltersCategoryIds !== undefined) {
                localVarQueryParameter['event_filters.category_ids'] = eventFiltersCategoryIds;
            }
            if (eventSorting !== undefined) {
                localVarQueryParameter['event_sorting'] = eventSorting;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search events, products and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {Array<SearchTypeFilter>} [types]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchGet: (xPlatformKey, searchTerm, types, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (types) {
                localVarQueryParameter['types'] = types;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary New endpoint for searching products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {number} [productFiltersMinimumPrice]
         * @param {number} [productFiltersMaximumPrice]
         * @param {string} [productFiltersCurrencyCode]
         * @param {ProductStatus} [productFiltersProductStatus]
         * @param {string} [productFiltersCategoryIds]
         * @param {ProductSorting} [productSorting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchProductsGet: (xPlatformKey, searchTerm, offset, pageSize, productFiltersMinimumPrice, productFiltersMaximumPrice, productFiltersCurrencyCode, productFiltersProductStatus, productFiltersCategoryIds, productSorting, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchProductsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (productFiltersMinimumPrice !== undefined) {
                localVarQueryParameter['product_filters.minimum_price'] = productFiltersMinimumPrice;
            }
            if (productFiltersMaximumPrice !== undefined) {
                localVarQueryParameter['product_filters.maximum_price'] = productFiltersMaximumPrice;
            }
            if (productFiltersCurrencyCode !== undefined) {
                localVarQueryParameter['product_filters.currency_code'] = productFiltersCurrencyCode;
            }
            if (productFiltersProductStatus !== undefined) {
                localVarQueryParameter['product_filters.product_status'] = productFiltersProductStatus;
            }
            if (productFiltersCategoryIds !== undefined) {
                localVarQueryParameter['product_filters.category_ids'] = productFiltersCategoryIds;
            }
            if (productSorting !== undefined) {
                localVarQueryParameter['product_sorting'] = productSorting;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get search suggestions
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [numberOfSuggestions]
         * @param {Array<CategoryType>} [categoryTypes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchSuggestionsGet: (xPlatformKey, searchTerm, numberOfSuggestions, categoryTypes, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2SearchSuggestionsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (numberOfSuggestions !== undefined) {
                localVarQueryParameter['number_of_suggestions'] = numberOfSuggestions;
            }
            if (categoryTypes) {
                localVarQueryParameter['category_types'] = categoryTypes;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function (configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary New endpoint for searching products, events and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [numberOfProducts]
         * @param {number} [numberOfEvents]
         * @param {number} [numberOfTeamCategories]
         * @param {number} [numberOfLeagueCategories]
         * @param {number} [numberOfOtherCategories]
         * @param {number} [numberOfCampaignCategories]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchAllGet(xPlatformKey, searchTerm, numberOfProducts, numberOfEvents, numberOfTeamCategories, numberOfLeagueCategories, numberOfOtherCategories, numberOfCampaignCategories, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchAllGet(xPlatformKey, searchTerm, numberOfProducts, numberOfEvents, numberOfTeamCategories, numberOfLeagueCategories, numberOfOtherCategories, numberOfCampaignCategories, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary New endpoint for searching categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {'teams' | 'leagues' | 'other' | 'campaigns'} [categorySearchType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchCategoriesGet(xPlatformKey, searchTerm, offset, pageSize, categorySearchType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchCategoriesGet(xPlatformKey, searchTerm, offset, pageSize, categorySearchType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary New endpoint for searching events
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {EventStatus} [eventFiltersEventStatus]
         * @param {string} [eventFiltersCategoryIds]
         * @param {EventSorting} [eventSorting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchEventsGet(xPlatformKey, searchTerm, offset, pageSize, eventFiltersEventStatus, eventFiltersCategoryIds, eventSorting, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchEventsGet(xPlatformKey, searchTerm, offset, pageSize, eventFiltersEventStatus, eventFiltersCategoryIds, eventSorting, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search events, products and categories
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {Array<SearchTypeFilter>} [types]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchGet(xPlatformKey, searchTerm, types, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchGet(xPlatformKey, searchTerm, types, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary New endpoint for searching products
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {number} [productFiltersMinimumPrice]
         * @param {number} [productFiltersMaximumPrice]
         * @param {string} [productFiltersCurrencyCode]
         * @param {ProductStatus} [productFiltersProductStatus]
         * @param {string} [productFiltersCategoryIds]
         * @param {ProductSorting} [productSorting]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchProductsGet(xPlatformKey, searchTerm, offset, pageSize, productFiltersMinimumPrice, productFiltersMaximumPrice, productFiltersCurrencyCode, productFiltersProductStatus, productFiltersCategoryIds, productSorting, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchProductsGet(xPlatformKey, searchTerm, offset, pageSize, productFiltersMinimumPrice, productFiltersMaximumPrice, productFiltersCurrencyCode, productFiltersProductStatus, productFiltersCategoryIds, productSorting, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get search suggestions
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm]
         * @param {number} [numberOfSuggestions]
         * @param {Array<CategoryType>} [categoryTypes]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchSuggestionsGet(xPlatformKey, searchTerm, numberOfSuggestions, categoryTypes, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SearchSuggestionsGet(xPlatformKey, searchTerm, numberOfSuggestions, categoryTypes, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SearchApiFp(configuration);
    return {
        /**
         *
         * @summary New endpoint for searching products, events and categories
         * @param {SearchApiV2SearchAllGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchAllGet(requestParameters, options) {
            return localVarFp.v2SearchAllGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.numberOfProducts, requestParameters.numberOfEvents, requestParameters.numberOfTeamCategories, requestParameters.numberOfLeagueCategories, requestParameters.numberOfOtherCategories, requestParameters.numberOfCampaignCategories, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary New endpoint for searching categories
         * @param {SearchApiV2SearchCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchCategoriesGet(requestParameters, options) {
            return localVarFp.v2SearchCategoriesGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.categorySearchType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary New endpoint for searching events
         * @param {SearchApiV2SearchEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchEventsGet(requestParameters, options) {
            return localVarFp.v2SearchEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.eventFiltersEventStatus, requestParameters.eventFiltersCategoryIds, requestParameters.eventSorting, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search events, products and categories
         * @param {SearchApiV2SearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchGet(requestParameters, options) {
            return localVarFp.v2SearchGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary New endpoint for searching products
         * @param {SearchApiV2SearchProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchProductsGet(requestParameters, options) {
            return localVarFp.v2SearchProductsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.productFiltersMinimumPrice, requestParameters.productFiltersMaximumPrice, requestParameters.productFiltersCurrencyCode, requestParameters.productFiltersProductStatus, requestParameters.productFiltersCategoryIds, requestParameters.productSorting, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get search suggestions
         * @param {SearchApiV2SearchSuggestionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SearchSuggestionsGet(requestParameters, options) {
            return localVarFp.v2SearchSuggestionsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.numberOfSuggestions, requestParameters.categoryTypes, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI {
    /**
     *
     * @summary New endpoint for searching products, events and categories
     * @param {SearchApiV2SearchAllGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchAllGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchAllGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.numberOfProducts, requestParameters.numberOfEvents, requestParameters.numberOfTeamCategories, requestParameters.numberOfLeagueCategories, requestParameters.numberOfOtherCategories, requestParameters.numberOfCampaignCategories, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary New endpoint for searching categories
     * @param {SearchApiV2SearchCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchCategoriesGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchCategoriesGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.categorySearchType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary New endpoint for searching events
     * @param {SearchApiV2SearchEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchEventsGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchEventsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.eventFiltersEventStatus, requestParameters.eventFiltersCategoryIds, requestParameters.eventSorting, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search events, products and categories
     * @param {SearchApiV2SearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.types, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary New endpoint for searching products
     * @param {SearchApiV2SearchProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchProductsGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchProductsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.productFiltersMinimumPrice, requestParameters.productFiltersMaximumPrice, requestParameters.productFiltersCurrencyCode, requestParameters.productFiltersProductStatus, requestParameters.productFiltersCategoryIds, requestParameters.productSorting, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get search suggestions
     * @param {SearchApiV2SearchSuggestionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    v2SearchSuggestionsGet(requestParameters, options) {
        return SearchApiFp(this.configuration).v2SearchSuggestionsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.numberOfSuggestions, requestParameters.categoryTypes, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SegmentProtocolViolationsApi - axios parameter creator
 * @export
 */
export const SegmentProtocolViolationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {V2SegmentViolationsPostRequest} [v2SegmentViolationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SegmentViolationsPost: (v2SegmentViolationsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v2/segment/violations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = v2SegmentViolationsPostRequest;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SegmentProtocolViolationsApi - functional programming interface
 * @export
 */
export const SegmentProtocolViolationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SegmentProtocolViolationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {V2SegmentViolationsPostRequest} [v2SegmentViolationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SegmentViolationsPost(v2SegmentViolationsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2SegmentViolationsPost(v2SegmentViolationsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SegmentProtocolViolationsApi - factory interface
 * @export
 */
export const SegmentProtocolViolationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SegmentProtocolViolationsApiFp(configuration);
    return {
        /**
         *
         * @param {SegmentProtocolViolationsApiV2SegmentViolationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2SegmentViolationsPost(requestParameters = {}, options) {
            return localVarFp.v2SegmentViolationsPost(requestParameters.v2SegmentViolationsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SegmentProtocolViolationsApi - object-oriented interface
 * @export
 * @class SegmentProtocolViolationsApi
 * @extends {BaseAPI}
 */
export class SegmentProtocolViolationsApi extends BaseAPI {
    /**
     *
     * @param {SegmentProtocolViolationsApiV2SegmentViolationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentProtocolViolationsApi
     */
    v2SegmentViolationsPost(requestParameters = {}, options) {
        return SegmentProtocolViolationsApiFp(this.configuration).v2SegmentViolationsPost(requestParameters.v2SegmentViolationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ShippingCostApi - axios parameter creator
 * @export
 */
export const ShippingCostApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {string} xPlatformKey Select the platform.
         * @param {FramingType} [framingType] The framing type for the product to be shipped
         * @param {ShippingType} [shippingType] The shipping type for the product to be shipped
         * @param {string} [shippingOfficeId] The shipping office the product will be shipped from
         * @param {string} [destinationCountryCode] The destination country code to ship to
         * @param {boolean} [applyVat] Whether the shipping costs should included vat or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ShippingCostGet: (xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('v2ShippingCostGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/v2/shipping-cost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (framingType !== undefined) {
                localVarQueryParameter['framing_type'] = framingType;
            }
            if (shippingType !== undefined) {
                localVarQueryParameter['shipping_type'] = shippingType;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shipping_office_id'] = shippingOfficeId;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['destination_country_code'] = destinationCountryCode;
            }
            if (applyVat !== undefined) {
                localVarQueryParameter['apply_vat'] = applyVat;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ShippingCostApi - functional programming interface
 * @export
 */
export const ShippingCostApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShippingCostApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {string} xPlatformKey Select the platform.
         * @param {FramingType} [framingType] The framing type for the product to be shipped
         * @param {ShippingType} [shippingType] The shipping type for the product to be shipped
         * @param {string} [shippingOfficeId] The shipping office the product will be shipped from
         * @param {string} [destinationCountryCode] The destination country code to ship to
         * @param {boolean} [applyVat] Whether the shipping costs should included vat or not
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ShippingCostGet(xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ShippingCostGet(xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ShippingCostApi - factory interface
 * @export
 */
export const ShippingCostApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShippingCostApiFp(configuration);
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {ShippingCostApiV2ShippingCostGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ShippingCostGet(requestParameters, options) {
            return localVarFp.v2ShippingCostGet(requestParameters.xPlatformKey, requestParameters.framingType, requestParameters.shippingType, requestParameters.shippingOfficeId, requestParameters.destinationCountryCode, requestParameters.applyVat, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShippingCostApi - object-oriented interface
 * @export
 * @class ShippingCostApi
 * @extends {BaseAPI}
 */
export class ShippingCostApi extends BaseAPI {
    /**
     *
     * @summary Calculate the shipping costs for a product with given shipping information.
     * @param {ShippingCostApiV2ShippingCostGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingCostApi
     */
    v2ShippingCostGet(requestParameters, options) {
        return ShippingCostApiFp(this.configuration).v2ShippingCostGet(requestParameters.xPlatformKey, requestParameters.framingType, requestParameters.shippingType, requestParameters.shippingOfficeId, requestParameters.destinationCountryCode, requestParameters.applyVat, options).then((request) => request(this.axios, this.basePath));
    }
}
